import * as React from 'react';
import * as _ from 'lodash';
import classNames from 'classnames';
import { Field } from 'redux-form';
import { Form } from 'redux-form';
import Dropdown from './../PageLayout/DropDowns/SimpleDropDown/SimpleDropDown';
import CheckBox from './../PageLayout/CheckBox';
import Footer from './AddNewEntityFooter.rt';
import Permissions from './../PageLayout/Popups/Permissions';
import ResetPasswordPopup from './ResetPasswordPopupOLD';
import formField from './formField';
import { formTextAreaField } from './formField';
import { formCheckBoxField } from './formField';
import { required } from './formField';
import { conditionalRequired } from './formField';
import { phoneValidator } from './formField';
import { requiredPhoneValidator } from './formField';
import { requiredWithLength } from './formField';
import { hiddenField } from './formField';
import misc from './../../misc';
import { ESignatureComponent as ESignature } from './../eSignature/eSignature';
import FingerSignature from './../FingerSignature';
import { PARTS } from './../../schemas/accessRightsModel';
export default function () {
    function onClick1(showSendResetPasswordPopup, showChangePasswordPopup, user, clientType, handleClosePopup, handleShowPopup, authGoogleCalendar, isEmployee, isCustomer, isFabricator, isMasterFabricator, isStore, isNew, AR, isMaster, canEditFields, canChangePassword, canAddFabricator, paymentProfile, canEditPrimaryEmail, subscriptionEditable, fabricatorId) {
        this.handleShowPopup('permissions');
    }
    function onClick2(showSendResetPasswordPopup, showChangePasswordPopup, user, clientType, handleClosePopup, handleShowPopup, authGoogleCalendar, isEmployee, isCustomer, isFabricator, isMasterFabricator, isStore, isNew, AR, isMaster, canEditFields, canChangePassword, canAddFabricator, paymentProfile, canEditPrimaryEmail, subscriptionEditable, fabricatorId) {
        this.handleShowPopupEx('stores');
    }
    function onClick3(showSendResetPasswordPopup, showChangePasswordPopup, user, clientType, handleClosePopup, handleShowPopup, authGoogleCalendar, isEmployee, isCustomer, isFabricator, isMasterFabricator, isStore, isNew, AR, isMaster, canEditFields, canChangePassword, canAddFabricator, paymentProfile, canEditPrimaryEmail, subscriptionEditable, fabricatorId) {
        this.handleShowPopupEx('fabricators');
    }
    function onClick4(showSendResetPasswordPopup, showChangePasswordPopup, user, clientType, handleClosePopup, handleShowPopup, authGoogleCalendar, isEmployee, isCustomer, isFabricator, isMasterFabricator, isStore, isNew, AR, isMaster, canEditFields, canChangePassword, canAddFabricator, paymentProfile, canEditPrimaryEmail, subscriptionEditable, fabricatorId) {
        this.props.showMasterProfileSelection(this.props.assignedMasterProfile);
    }
    function onChange5(showSendResetPasswordPopup, showChangePasswordPopup, user, clientType, handleClosePopup, handleShowPopup, authGoogleCalendar, isEmployee, isCustomer, isFabricator, isMasterFabricator, isStore, isNew, AR, isMaster, canEditFields, canChangePassword, canAddFabricator, paymentProfile, canEditPrimaryEmail, subscriptionEditable, fabricatorId, e) {
        this.handleUploadFieldChange(e);
    }
    function onClick6(showSendResetPasswordPopup, showChangePasswordPopup, user, clientType, handleClosePopup, handleShowPopup, authGoogleCalendar, isEmployee, isCustomer, isFabricator, isMasterFabricator, isStore, isNew, AR, isMaster, canEditFields, canChangePassword, canAddFabricator, paymentProfile, canEditPrimaryEmail, subscriptionEditable, fabricatorId) {
        this.setState({ showCreditCardOverlay: true });
    }
    function onChange7(showSendResetPasswordPopup, showChangePasswordPopup, user, clientType, handleClosePopup, handleShowPopup, authGoogleCalendar, isEmployee, isCustomer, isFabricator, isMasterFabricator, isStore, isNew, AR, isMaster, canEditFields, canChangePassword, canAddFabricator, paymentProfile, canEditPrimaryEmail, subscriptionEditable, fabricatorId, e, value) {
        this.setState({ ccName: value });
    }
    function onChange8(showSendResetPasswordPopup, showChangePasswordPopup, user, clientType, handleClosePopup, handleShowPopup, authGoogleCalendar, isEmployee, isCustomer, isFabricator, isMasterFabricator, isStore, isNew, AR, isMaster, canEditFields, canChangePassword, canAddFabricator, paymentProfile, canEditPrimaryEmail, subscriptionEditable, fabricatorId, value) {
        {
        }
    }
    function onChange9(showSendResetPasswordPopup, showChangePasswordPopup, user, clientType, handleClosePopup, handleShowPopup, authGoogleCalendar, isEmployee, isCustomer, isFabricator, isMasterFabricator, isStore, isNew, AR, isMaster, canEditFields, canChangePassword, canAddFabricator, paymentProfile, canEditPrimaryEmail, subscriptionEditable, fabricatorId, value) {
        {
        }
    }
    function onChange10(showSendResetPasswordPopup, showChangePasswordPopup, user, clientType, handleClosePopup, handleShowPopup, authGoogleCalendar, isEmployee, isCustomer, isFabricator, isMasterFabricator, isStore, isNew, AR, isMaster, canEditFields, canChangePassword, canAddFabricator, paymentProfile, canEditPrimaryEmail, subscriptionEditable, fabricatorId, value) {
        {
        }
    }
    function onChange11(showSendResetPasswordPopup, showChangePasswordPopup, user, clientType, handleClosePopup, handleShowPopup, authGoogleCalendar, isEmployee, isCustomer, isFabricator, isMasterFabricator, isStore, isNew, AR, isMaster, canEditFields, canChangePassword, canAddFabricator, paymentProfile, canEditPrimaryEmail, subscriptionEditable, fabricatorId, value) {
        {
        }
    }
    function onChange12(showSendResetPasswordPopup, showChangePasswordPopup, user, clientType, handleClosePopup, handleShowPopup, authGoogleCalendar, isEmployee, isCustomer, isFabricator, isMasterFabricator, isStore, isNew, AR, isMaster, canEditFields, canChangePassword, canAddFabricator, paymentProfile, canEditPrimaryEmail, subscriptionEditable, fabricatorId, value) {
        {
        }
    }
    function onClick13(showSendResetPasswordPopup, showChangePasswordPopup, user, clientType, handleClosePopup, handleShowPopup, authGoogleCalendar, isEmployee, isCustomer, isFabricator, isMasterFabricator, isStore, isNew, AR, isMaster, canEditFields, canChangePassword, canAddFabricator, paymentProfile, canEditPrimaryEmail, subscriptionEditable, fabricatorId) {
        authGoogleCalendar(this.state.entityId);
    }
    function onClick14(showSendResetPasswordPopup, showChangePasswordPopup, user, clientType, handleClosePopup, handleShowPopup, authGoogleCalendar, isEmployee, isCustomer, isFabricator, isMasterFabricator, isStore, isNew, AR, isMaster, canEditFields, canChangePassword, canAddFabricator, paymentProfile, canEditPrimaryEmail, subscriptionEditable, fabricatorId) {
        this.setState({ showDepositDisclaimer: true });
    }
    function onClick15(showSendResetPasswordPopup, showChangePasswordPopup, user, clientType, handleClosePopup, handleShowPopup, authGoogleCalendar, isEmployee, isCustomer, isFabricator, isMasterFabricator, isStore, isNew, AR, isMaster, canEditFields, canChangePassword, canAddFabricator, paymentProfile, canEditPrimaryEmail, subscriptionEditable, fabricatorId) {
        handleShowPopup('resetPassword');
    }
    function onClick16(showSendResetPasswordPopup, showChangePasswordPopup, user, clientType, handleClosePopup, handleShowPopup, authGoogleCalendar, isEmployee, isCustomer, isFabricator, isMasterFabricator, isStore, isNew, AR, isMaster, canEditFields, canChangePassword, canAddFabricator, paymentProfile, canEditPrimaryEmail, subscriptionEditable, fabricatorId) {
        handleShowPopup('changePassword');
    }
    function onChange17(showSendResetPasswordPopup, showChangePasswordPopup, user, clientType, handleClosePopup, handleShowPopup, authGoogleCalendar, isEmployee, isCustomer, isFabricator, isMasterFabricator, isStore, isNew, AR, isMaster, canEditFields, canChangePassword, canAddFabricator, paymentProfile, canEditPrimaryEmail, subscriptionEditable, fabricatorId, showBV, value) {
        this.updateProgramType('bathroom', value);
    }
    function onChange18(showSendResetPasswordPopup, showChangePasswordPopup, user, clientType, handleClosePopup, handleShowPopup, authGoogleCalendar, isEmployee, isCustomer, isFabricator, isMasterFabricator, isStore, isNew, AR, isMaster, canEditFields, canChangePassword, canAddFabricator, paymentProfile, canEditPrimaryEmail, subscriptionEditable, fabricatorId, showBV, value) {
        this.updatePaymentType('bathroom', value);
    }
    function scopeSub19(showSendResetPasswordPopup, showChangePasswordPopup, user, clientType, handleClosePopup, handleShowPopup, authGoogleCalendar, isEmployee, isCustomer, isFabricator, isMasterFabricator, isStore, isNew, AR, isMaster, canEditFields, canChangePassword, canAddFabricator, paymentProfile, canEditPrimaryEmail, subscriptionEditable, fabricatorId, showBV) {
        var sub = _.find(this.props.subscriptions, s => this.state.bathroomPaymentType && s.id === this.state.bathroomPaymentType.id) || {};
        return React.createElement('div', { 'className': 'settings-options' }, !sub.type ? ['\r\n                  Select a Program Type\r\n                '] : null, sub.type && sub.type === 'free' ? ['\r\n                  FREE TRIAL\r\n                '] : null, sub.type && sub.type !== 'free' ? [
            React.createElement('h5', { 'key': '282531' }, 'Only'),
            React.createElement('h2', { 'key': '282533' }, '$', sub.price.toFixed(2)),
            React.createElement('h5', { 'key': '282535' }, 'per ', sub.period === 'monthly' ? 'month' : sub.period === 'annually' ? 'year' : sub.period)
        ] : null);
    }
    function onChange20(showSendResetPasswordPopup, showChangePasswordPopup, user, clientType, handleClosePopup, handleShowPopup, authGoogleCalendar, isEmployee, isCustomer, isFabricator, isMasterFabricator, isStore, isNew, AR, isMaster, canEditFields, canChangePassword, canAddFabricator, paymentProfile, canEditPrimaryEmail, subscriptionEditable, fabricatorId, showBV, value) {
        this.updateProgramType('kitchen', value);
    }
    function onChange21(showSendResetPasswordPopup, showChangePasswordPopup, user, clientType, handleClosePopup, handleShowPopup, authGoogleCalendar, isEmployee, isCustomer, isFabricator, isMasterFabricator, isStore, isNew, AR, isMaster, canEditFields, canChangePassword, canAddFabricator, paymentProfile, canEditPrimaryEmail, subscriptionEditable, fabricatorId, showBV, value) {
        this.updatePaymentType('kitchen', value);
    }
    function scopeSub22(showSendResetPasswordPopup, showChangePasswordPopup, user, clientType, handleClosePopup, handleShowPopup, authGoogleCalendar, isEmployee, isCustomer, isFabricator, isMasterFabricator, isStore, isNew, AR, isMaster, canEditFields, canChangePassword, canAddFabricator, paymentProfile, canEditPrimaryEmail, subscriptionEditable, fabricatorId, showBV) {
        var sub = _.find(this.props.subscriptions, s => this.state.kitchenPaymentType && s.id == this.state.kitchenPaymentType.id) || {};
        return React.createElement('div', { 'className': 'settings-options' }, !sub.type ? ['\r\n                  Select a Program Type\r\n                '] : null, sub.type && sub.type == 'free' ? ['\r\n                  FREE TRIAL\r\n                '] : null, sub.type && sub.type != 'free' ? [
            React.createElement('h5', { 'key': '322021' }, 'Only'),
            React.createElement('h2', { 'key': '322023' }, '$', sub.price.toFixed(2)),
            React.createElement('h5', { 'key': '322025' }, 'per ', sub.period == 'monthly' ? 'month' : sub.period == 'annually' ? 'year' : sub.period),
            sub.type && sub.contractPeriod == 'annually' && sub.period == 'annually' ? React.createElement('h5', { 'key': '322027' }, '($', (sub.price / 12).toFixed(2), ' per month)') : null
        ] : null);
    }
    function scopeShowBV23(showSendResetPasswordPopup, showChangePasswordPopup, user, clientType, handleClosePopup, handleShowPopup, authGoogleCalendar, isEmployee, isCustomer, isFabricator, isMasterFabricator, isStore, isNew, AR, isMaster, canEditFields, canChangePassword, canAddFabricator, paymentProfile, canEditPrimaryEmail, subscriptionEditable, fabricatorId) {
        var showBV = !window.location.host.toLowerCase().includes('quotecountertops.com') && !window.location.host.toLowerCase().includes('granitefabricatorsdirect.com') && !window.location.host.toLowerCase().includes('quotegranite.com');
        return React.createElement('div', {
            'className': 'new-account-block',
            'key': '22928'
        }, AR.isSiteAdmin(false) ? React.createElement('div', {
            'className': 'new-account-block-column new-account-block-column--third',
            'key': '23341'
        }, React.createElement('div', { 'className': 'new-account-lir title' }, React.createElement('div', { 'className': 'new-account-col title' }, React.createElement('div', {}, 'Fabricator Account Settings'))), React.createElement('div', { 'className': 'new-account-lir' }, React.createElement('div', { 'className': 'new-account-col' }, React.createElement(Field, {
            'name': 'accountId',
            'component': formField,
            'label': 'External Account Id',
            'type': 'text',
            'disabled': !canEditFields
        }))), AR.isSiteAdmin(false) ? React.createElement('div', {
            'className': 'new-account-lir',
            'key': '23892'
        }, React.createElement('div', { 'className': 'new-account-col' }, React.createElement(Field, {
            'name': 'subscriptionEditable',
            'component': formCheckBoxField,
            'onChecked': this.updateCheckBoxField,
            'labelEnabled': 'Subscription Editable',
            'labelDisabled': 'Subscription Editable'
        }))) : null, (this.props.homeAdvisorApiEndpointUrl || '').length > 0 ? React.createElement('div', {
            'className': 'new-account-lir',
            'key': '24275'
        }, React.createElement('div', { 'className': 'new-account-col' }, React.createElement('div', { 'className': 'new-account-text-box-wrapper' }, React.createElement('span', {
            'onClick': this.copyHomeAdvisorApiEndpointUrl,
            'title': 'click to copy to clipboard'
        }, this.props.homeAdvisorApiEndpointUrl)), React.createElement('div', { 'className': 'new-account-underline-text' }, 'Home Advisor Lead Push Api Endpoint'), React.createElement('div', { 'className': classNames('new-account-notice', { 'new-account-notice--visible': this.state.showCopied }) }, '\r\n              Copied to Clipboard\r\n            '))) : null, AR.isSiteAdmin(false) ? React.createElement('div', {
            'className': 'new-account-lir',
            'key': '24989'
        }, React.createElement('div', { 'className': 'new-account-col' }, React.createElement(Field, {
            'name': 'hideCheckoutBreakdownCost',
            'component': formCheckBoxField,
            'onChecked': this.updateCheckBoxField,
            'labelEnabled': 'Hide Checkout Line Item Prices',
            'labelDisabled': 'Hide Checkout Line Item Prices'
        }))) : null) : null, React.createElement('div', { 'className': 'new-account-block-column new-account-block-column--twothirds new-account-block-column--twothirds_right' }, isFabricator ? React.createElement('div', {
            'className': 'new-account-lir new-account-analytics',
            'key': '25544'
        }, React.createElement(Field, {
            'name': 'analytics',
            'component': formTextAreaField,
            'label': 'Analytics',
            'placeholder': 'Copy/Paste your Analytics code here'
        })) : null), showBV ? React.createElement('div', {
            'className': 'new-account-block-column new-account-block-column--half',
            'key': '25814'
        }, React.createElement('div', { 'className': 'new-account-subscription' }, subscriptionEditable || isNew ? React.createElement('div', {
            'className': 'new-account-subscription--bv',
            'key': '25958'
        }, React.createElement('h4', {}, 'Bathroom Settings'), this.props.subscriptions.length >= 1 ? React.createElement('div', {
            'className': 'new-account-block-column new-account-block-column--twothirds border-right',
            'key': '26092'
        }, React.createElement('div', { 'className': 'new-account-subscription-options' }, isMasterFabricator ? [React.createElement(Dropdown, {
                'id': 'bathroom-program-type',
                'values': this.getProgramTypes(this.state.initialBathroomProgramType, 'bathroom'),
                'activeValue': this.state.bathroomProgramType,
                'underlineText': 'Program Type',
                'onChange': onChange17.bind(this, showSendResetPasswordPopup, showChangePasswordPopup, user, clientType, handleClosePopup, handleShowPopup, authGoogleCalendar, isEmployee, isCustomer, isFabricator, isMasterFabricator, isStore, isNew, AR, isMaster, canEditFields, canChangePassword, canAddFabricator, paymentProfile, canEditPrimaryEmail, subscriptionEditable, fabricatorId, showBV),
                'key': '263221'
            })] : null, !isMasterFabricator ? [this.state.bathroomProgramType] : null), React.createElement('div', { 'className': 'new-account-subscription-options new-account-block-sub-lir' }, isMasterFabricator ? [React.createElement(Dropdown, {
                'id': 'bathroom-payment-type',
                'values': this.getPaymentTypes('bathroom'),
                'activeValue': this.state.bathroomPaymentType,
                'underlineText': 'Payment Type',
                'onChange': onChange18.bind(this, showSendResetPasswordPopup, showChangePasswordPopup, user, clientType, handleClosePopup, handleShowPopup, authGoogleCalendar, isEmployee, isCustomer, isFabricator, isMasterFabricator, isStore, isNew, AR, isMaster, canEditFields, canChangePassword, canAddFabricator, paymentProfile, canEditPrimaryEmail, subscriptionEditable, fabricatorId, showBV),
                'disabled': this.getPaymentTypes('bathroom').length <= 1,
                'key': '269991'
            })] : null, !isMasterFabricator ? [this.state.bathroomPaymentType.text] : null)) : null, this.props.subscriptions.length >= 1 ? React.createElement('div', {
            'className': 'new-account-block-column--third new-account-block-column--third_right',
            'key': '27626'
        }, scopeSub19.apply(this, [
            showSendResetPasswordPopup,
            showChangePasswordPopup,
            user,
            clientType,
            handleClosePopup,
            handleShowPopup,
            authGoogleCalendar,
            isEmployee,
            isCustomer,
            isFabricator,
            isMasterFabricator,
            isStore,
            isNew,
            AR,
            isMaster,
            canEditFields,
            canChangePassword,
            canAddFabricator,
            paymentProfile,
            canEditPrimaryEmail,
            subscriptionEditable,
            fabricatorId,
            showBV
        ])) : null) : null), React.createElement('div', { 'className': 'new-account-block-sub-lir' }, false ? [
            ,
            isMasterFabricator ? [
                React.createElement('div', {
                    'className': 'new-account-block-column new-account-block-column--half checkbox',
                    'key': '287741'
                }, React.createElement(Field, {
                    'name': 'enableBQ',
                    'component': formCheckBoxField,
                    'disabled': !canEditFields,
                    'onChecked': this.updateCheckBoxField,
                    'labelEnabled': 'Enable Quoting',
                    'labelDisabled': 'Enable Quoting'
                })),
                isMasterFabricator ? React.createElement('div', {
                    'className': 'new-account-block-column new-account-block-column--half new-account-block-column--half checkbox',
                    'key': '287743'
                }, React.createElement(Field, {
                    'name': 'enableBV',
                    'component': formCheckBoxField,
                    'disabled': !canEditFields,
                    'onChecked': this.updateCheckBoxField,
                    'labelEnabled': 'Enable Visualization',
                    'labelDisabled': 'Enable Visualization'
                })) : null
            ] : null
        ] : null)) : null, React.createElement('div', { 'className': 'new-account-block-column new-account-block-column--half ' + (showBV ? 'new-account-block-column--half_right' : '') }, React.createElement('div', { 'className': 'new-account-subscription' }, subscriptionEditable || isNew ? React.createElement('div', {
            'className': 'new-account-subscription--bv',
            'key': '29924'
        }, React.createElement('h4', {}, 'Kitchen Settings'), this.props.subscriptions.length >= 1 ? React.createElement('div', {
            'className': 'new-account-block-column new-account-block-column--twothirds border-right',
            'key': '30057'
        }, React.createElement('div', { 'className': 'new-account-subscription-options' }, isMasterFabricator ? [React.createElement(Dropdown, {
                'id': 'kitchen-program-type',
                'values': this.getProgramTypes(this.state.initialKitchenProgramType, 'kitchen'),
                'activeValue': this.state.kitchenProgramType,
                'underlineText': 'Program Type',
                'onChange': onChange20.bind(this, showSendResetPasswordPopup, showChangePasswordPopup, user, clientType, handleClosePopup, handleShowPopup, authGoogleCalendar, isEmployee, isCustomer, isFabricator, isMasterFabricator, isStore, isNew, AR, isMaster, canEditFields, canChangePassword, canAddFabricator, paymentProfile, canEditPrimaryEmail, subscriptionEditable, fabricatorId, showBV),
                'key': '302871'
            })] : null, !isMasterFabricator ? [this.state.kitchenProgramType] : null), React.createElement('div', { 'className': 'new-account-subscription-options new-account-block-sub-lir' }, isMasterFabricator ? [React.createElement(Dropdown, {
                'id': 'kitchen-payment-type',
                'values': this.getPaymentTypes('kitchen'),
                'activeValue': this.state.kitchenPaymentType,
                'underlineText': 'Payment Type',
                'onChange': onChange21.bind(this, showSendResetPasswordPopup, showChangePasswordPopup, user, clientType, handleClosePopup, handleShowPopup, authGoogleCalendar, isEmployee, isCustomer, isFabricator, isMasterFabricator, isStore, isNew, AR, isMaster, canEditFields, canChangePassword, canAddFabricator, paymentProfile, canEditPrimaryEmail, subscriptionEditable, fabricatorId, showBV),
                'disabled': this.getPaymentTypes('kitchen').length <= 1,
                'key': '309581'
            })] : null, !isMasterFabricator ? [this.state.kitchenPaymentType.text] : null)) : null, this.props.subscriptions.length >= 1 ? React.createElement('div', {
            'className': 'new-account-block-column--third new-account-block-column--third_right',
            'key': '31579'
        }, scopeSub22.apply(this, [
            showSendResetPasswordPopup,
            showChangePasswordPopup,
            user,
            clientType,
            handleClosePopup,
            handleShowPopup,
            authGoogleCalendar,
            isEmployee,
            isCustomer,
            isFabricator,
            isMasterFabricator,
            isStore,
            isNew,
            AR,
            isMaster,
            canEditFields,
            canChangePassword,
            canAddFabricator,
            paymentProfile,
            canEditPrimaryEmail,
            subscriptionEditable,
            fabricatorId,
            showBV
        ])) : null) : null), React.createElement('div', { 'className': 'new-account-block-sub-lir' }, isMasterFabricator ? [
            React.createElement('div', {
                'className': 'new-account-block-column new-account-block-column--half checkbox',
                'key': '327981'
            }, AR.v(PARTS.FAB_TOGGLE_BUTTON_KV_ENABLE_QUOTING) ? React.createElement(Field, {
                'name': 'enableQT',
                'component': formCheckBoxField,
                'disabled': true,
                'onChecked': this.updateCheckBoxField,
                'labelEnabled': 'Enable Quoting',
                'labelDisabled': 'Enable Quoting',
                'key': '32945'
            }) : null),
            React.createElement('div', {
                'className': 'new-account-block-column new-account-block-column--half new-account-block-column--half checkbox',
                'key': '327983'
            }, AR.v(PARTS.FAB_TOGGLE_BUTTON_KV_ENABLE_VISUALIZATION) ? React.createElement(Field, {
                'name': 'enableKV',
                'component': formCheckBoxField,
                'disabled': !canEditFields,
                'onChecked': this.updateCheckBoxField,
                'labelEnabled': 'Enable Visualization',
                'labelDisabled': 'Enable Visualization',
                'key': '33501'
            }) : null)
        ] : null), false ? [
            AR.v(PARTS.FAB_TOGGLE_BUTTON_KV_SHOW_PRICING) ? React.createElement(Field, {
                'name': 'showPricingKV',
                'component': formCheckBoxField,
                'onChecked': this.updateCheckBoxField,
                'labelEnabled': 'Show Pricing',
                'labelDisabled': 'Show Pricing',
                'disabled': AR.d(PARTS.FAB_TOGGLE_BUTTON_KV_SHOW_PRICING),
                'key': '339901'
            }) : null,
            AR.v(PARTS.FAB_TOGGLE_BUTTON_KV_CHECKOUT) ? React.createElement(Field, {
                'name': 'checkOutKV',
                'component': formCheckBoxField,
                'onChecked': this.updateCheckBoxField,
                'labelEnabled': 'CheckOut',
                'labelDisabled': 'CheckOut',
                'disabled': !this.props.formValues || !this.props.formValues.showPricing || AR.d(PARTS.FAB_TOGGLE_BUTTON_KV_CHECKOUT) || (this.state.paymentGateway_AuthNet_ApiLogin || '').length == 0,
                'key': '339903'
            }) : null,
            AR.v(PARTS.FAB_TOGGLE_BUTTON_KV_ADD_LABOR_CUSTOMER) ? React.createElement(Field, {
                'name': 'addLaborCustomerKV',
                'component': formCheckBoxField,
                'onChecked': this.updateCheckBoxField,
                'labelEnabled': 'Add Labor Customer',
                'labelDisabled': 'Add Labor Customer',
                'disabled': AR.d(PARTS.FAB_TOGGLE_BUTTON_KV_ADD_LABOR_CUSTOMER),
                'key': '339905'
            }) : null,
            AR.v(PARTS.FAB_TOGGLE_BUTTON_KV_SEPARATE_LABOR_IN_CART) ? React.createElement(Field, {
                'name': 'separateLaborInCartKV',
                'component': formCheckBoxField,
                'onChecked': this.updateCheckBoxField,
                'labelEnabled': 'Separate Labor in Cart',
                'labelDisabled': 'Separate Labor in Cart',
                'disabled': AR.d(PARTS.FAB_TOGGLE_BUTTON_KV_SEPARATE_LABOR_IN_CART) || !this.props.formValues || !this.props.formValues.showPricing,
                'key': '339907'
            }) : null,
            AR.v(PARTS.FAB_TOGGLE_BUTTON_KV_ENABLE_SHARING) ? React.createElement(Field, {
                'name': 'enableSharingKV',
                'component': formCheckBoxField,
                'onChecked': this.updateCheckBoxField,
                'labelEnabled': 'Enable Sharing',
                'labelDisabled': 'Enable Sharing',
                'disabled': AR.d(PARTS.FAB_TOGGLE_BUTTON_KV_ENABLE_SHARING),
                'key': '339909'
            }) : null,
            AR.v(PARTS.FAB_TOGGLE_BUTTON_KV_WIZARD_CONSUMERS) ? React.createElement(Field, {
                'name': 'wizardConsumersKV',
                'component': formCheckBoxField,
                'onChecked': this.updateCheckBoxField,
                'labelEnabled': 'Wizard Consumers',
                'labelDisabled': 'Wizard Consumers',
                'disabled': AR.d(PARTS.FAB_TOGGLE_BUTTON_KV_WIZARD_CONSUMERS),
                'key': '3399011'
            }) : null,
            AR.v(PARTS.FAB_TOGGLE_BUTTON_KV_WIZARD_CLIENTS) ? React.createElement(Field, {
                'name': 'wizardClientsKV',
                'component': formCheckBoxField,
                'onChecked': this.updateCheckBoxField,
                'labelEnabled': 'Wizard Clients',
                'labelDisabled': 'Wizard Clients',
                'disabled': AR.d(PARTS.FAB_TOGGLE_BUTTON_KV_WIZARD_CLIENTS),
                'key': '3399013'
            }) : null,
            AR.v(PARTS.FAB_TOGGLE_BUTTON_KV_2_FACTOR) ? React.createElement(Field, {
                'name': 'twoFAKV',
                'component': formCheckBoxField,
                'onChecked': this.updateCheckBoxField,
                'labelEnabled': '2 Factor',
                'labelDisabled': '2 Factor',
                'disabled': AR.d(PARTS.FAB_TOGGLE_BUTTON_KV_2_FACTOR) || !this.props.formValues || !this.props.formValues.leadCaptureKV,
                'key': '3399015'
            }) : null,
            AR.v(PARTS.FAB_TOGGLE_BUTTON_KV_LEAD_CAPTURE) ? React.createElement(Field, {
                'name': 'leadCaptureKV',
                'component': formCheckBoxField,
                'onChecked': this.updateCheckBoxField,
                'labelEnabled': 'Lead Capture',
                'labelDisabled': 'Lead Capture',
                'disabled': AR.d(PARTS.FAB_TOGGLE_BUTTON_KV_LEAD_CAPTURE),
                'key': '3399017'
            }) : null,
            AR.v(PARTS.FAB_TOGGLE_BUTTON_KV_ADD_LABOR_INSTALLER) ? React.createElement(Field, {
                'name': 'addLaborInstallerKV',
                'component': formCheckBoxField,
                'onChecked': this.updateCheckBoxField,
                'labelEnabled': 'Add Labor Installer',
                'labelDisabled': 'Add Labor Installer',
                'disabled': AR.d(PARTS.FAB_TOGGLE_BUTTON_KV_ADD_LABOR_INSTALLER),
                'key': '3399019'
            }) : null,
            AR.v(PARTS.FAB_TOGGLE_BUTTON_KV_VISUALIZER_ONLY) ? React.createElement(Field, {
                'name': 'visualizerOnlyKV',
                'component': formCheckBoxField,
                'onChecked': this.updateCheckBoxField,
                'labelEnabled': 'Visualizer Only',
                'labelDisabled': 'Visualizer Only',
                'disabled': AR.d(PARTS.FAB_TOGGLE_BUTTON_KV_VISUALIZER_ONLY),
                'key': '3399021'
            }) : null
        ] : null));
    }
    function onClick24(showSendResetPasswordPopup, showChangePasswordPopup, user, clientType, handleClosePopup, handleShowPopup, authGoogleCalendar, isEmployee, isCustomer, isFabricator, isMasterFabricator, isStore, isNew, AR, isMaster, canEditFields, canChangePassword, canAddFabricator, paymentProfile, canEditPrimaryEmail, subscriptionEditable, fabricatorId) {
        this.props.showNoCallFabricatorSelection(this.props.formValues.noCallFabricatorId, this.handleSetNoCallFabricator);
    }
    function onChange25(showSendResetPasswordPopup, showChangePasswordPopup, user, clientType, handleClosePopup, handleShowPopup, authGoogleCalendar, isEmployee, isCustomer, isFabricator, isMasterFabricator, isStore, isNew, AR, isMaster, canEditFields, canChangePassword, canAddFabricator, paymentProfile, canEditPrimaryEmail, subscriptionEditable, fabricatorId, value) {
        this.updateCurrency(value);
    }
    function onClick26(showSendResetPasswordPopup, showChangePasswordPopup, user, clientType, handleClosePopup, handleShowPopup, authGoogleCalendar, isEmployee, isCustomer, isFabricator, isMasterFabricator, isStore, isNew, AR, isMaster, canEditFields, canChangePassword, canAddFabricator, paymentProfile, canEditPrimaryEmail, subscriptionEditable, fabricatorId) {
        this.props.showNoCallFabricatorSelection(this.props.formValues.noCallFabricatorIdKitchen, this.handleSetNoCallFabricator, 'kitchen');
    }
    function onChange27(showSendResetPasswordPopup, showChangePasswordPopup, user, clientType, handleClosePopup, handleShowPopup, authGoogleCalendar, isEmployee, isCustomer, isFabricator, isMasterFabricator, isStore, isNew, AR, isMaster, canEditFields, canChangePassword, canAddFabricator, paymentProfile, canEditPrimaryEmail, subscriptionEditable, fabricatorId, value) {
        this.updateCurrency(value);
    }
    function onClick28(showSendResetPasswordPopup, showChangePasswordPopup, user, clientType, handleClosePopup, handleShowPopup, authGoogleCalendar, isEmployee, isCustomer, isFabricator, isMasterFabricator, isStore, isNew, AR, isMaster, canEditFields, canChangePassword, canAddFabricator, paymentProfile, canEditPrimaryEmail, subscriptionEditable, fabricatorId) {
        this.setState({ showDocuSignOverlay: true });
    }
    function onClick29(showSendResetPasswordPopup, showChangePasswordPopup, user, clientType, handleClosePopup, handleShowPopup, authGoogleCalendar, isEmployee, isCustomer, isFabricator, isMasterFabricator, isStore, isNew, AR, isMaster, canEditFields, canChangePassword, canAddFabricator, paymentProfile, canEditPrimaryEmail, subscriptionEditable, fabricatorId) {
        this.props.showFingerSignatureOverlayAction(true);
    }
    function onChange30(showSendResetPasswordPopup, showChangePasswordPopup, user, clientType, handleClosePopup, handleShowPopup, authGoogleCalendar, isEmployee, isCustomer, isFabricator, isMasterFabricator, isStore, isNew, AR, isMaster, canEditFields, canChangePassword, canAddFabricator, paymentProfile, canEditPrimaryEmail, subscriptionEditable, fabricatorId, value) {
        this.updateWebHookDataType(value);
    }
    function onClick31(showSendResetPasswordPopup, showChangePasswordPopup, user, clientType, handleClosePopup, handleShowPopup, authGoogleCalendar, isEmployee, isCustomer, isFabricator, isMasterFabricator, isStore, isNew, AR, isMaster, canEditFields, canChangePassword, canAddFabricator, paymentProfile, canEditPrimaryEmail, subscriptionEditable, fabricatorId) {
        this.setState({ showCreditCardOverlay: false });
    }
    function onClick32(showSendResetPasswordPopup, showChangePasswordPopup, user, clientType, handleClosePopup, handleShowPopup, authGoogleCalendar, isEmployee, isCustomer, isFabricator, isMasterFabricator, isStore, isNew, AR, isMaster, canEditFields, canChangePassword, canAddFabricator, paymentProfile, canEditPrimaryEmail, subscriptionEditable, fabricatorId, e) {
        misc.ignoreDefault(e);
    }
    function onClick33(showSendResetPasswordPopup, showChangePasswordPopup, user, clientType, handleClosePopup, handleShowPopup, authGoogleCalendar, isEmployee, isCustomer, isFabricator, isMasterFabricator, isStore, isNew, AR, isMaster, canEditFields, canChangePassword, canAddFabricator, paymentProfile, canEditPrimaryEmail, subscriptionEditable, fabricatorId) {
        this.setState({ showCreditCardOverlay: false });
    }
    function onChecked34(showSendResetPasswordPopup, showChangePasswordPopup, user, clientType, handleClosePopup, handleShowPopup, authGoogleCalendar, isEmployee, isCustomer, isFabricator, isMasterFabricator, isStore, isNew, AR, isMaster, canEditFields, canChangePassword, canAddFabricator, paymentProfile, canEditPrimaryEmail, subscriptionEditable, fabricatorId, e) {
        this.setState({ ccTermsApproved: !this.state.ccTermsApproved });
    }
    function onClick35(showSendResetPasswordPopup, showChangePasswordPopup, user, clientType, handleClosePopup, handleShowPopup, authGoogleCalendar, isEmployee, isCustomer, isFabricator, isMasterFabricator, isStore, isNew, AR, isMaster, canEditFields, canChangePassword, canAddFabricator, paymentProfile, canEditPrimaryEmail, subscriptionEditable, fabricatorId) {
        this.setState({ showCreditCardOverlay: false });
    }
    function onClick36(showSendResetPasswordPopup, showChangePasswordPopup, user, clientType, handleClosePopup, handleShowPopup, authGoogleCalendar, isEmployee, isCustomer, isFabricator, isMasterFabricator, isStore, isNew, AR, isMaster, canEditFields, canChangePassword, canAddFabricator, paymentProfile, canEditPrimaryEmail, subscriptionEditable, fabricatorId, e) {
        misc.ignoreDefault(e);
    }
    function onClick37(showSendResetPasswordPopup, showChangePasswordPopup, user, clientType, handleClosePopup, handleShowPopup, authGoogleCalendar, isEmployee, isCustomer, isFabricator, isMasterFabricator, isStore, isNew, AR, isMaster, canEditFields, canChangePassword, canAddFabricator, paymentProfile, canEditPrimaryEmail, subscriptionEditable, fabricatorId) {
        this.setState({ showDocuSignOverlay: false });
    }
    function onClick38(showSendResetPasswordPopup, showChangePasswordPopup, user, clientType, handleClosePopup, handleShowPopup, authGoogleCalendar, isEmployee, isCustomer, isFabricator, isMasterFabricator, isStore, isNew, AR, isMaster, canEditFields, canChangePassword, canAddFabricator, paymentProfile, canEditPrimaryEmail, subscriptionEditable, fabricatorId) {
        window.open('https://developers.docusign.com/oauth-token-generator', '_blank');
    }
    function onChecked39(showSendResetPasswordPopup, showChangePasswordPopup, user, clientType, handleClosePopup, handleShowPopup, authGoogleCalendar, isEmployee, isCustomer, isFabricator, isMasterFabricator, isStore, isNew, AR, isMaster, canEditFields, canChangePassword, canAddFabricator, paymentProfile, canEditPrimaryEmail, subscriptionEditable, fabricatorId, e) {
        this.setState({ ds_isProduction: !this.state.ds_isProduction });
    }
    function onClick40(showSendResetPasswordPopup, showChangePasswordPopup, user, clientType, handleClosePopup, handleShowPopup, authGoogleCalendar, isEmployee, isCustomer, isFabricator, isMasterFabricator, isStore, isNew, AR, isMaster, canEditFields, canChangePassword, canAddFabricator, paymentProfile, canEditPrimaryEmail, subscriptionEditable, fabricatorId) {
        this.setState({ showDocuSignOverlay: false });
    }
    function onClick41(showSendResetPasswordPopup, showChangePasswordPopup, user, clientType, handleClosePopup, handleShowPopup, authGoogleCalendar, isEmployee, isCustomer, isFabricator, isMasterFabricator, isStore, isNew, AR, isMaster, canEditFields, canChangePassword, canAddFabricator, paymentProfile, canEditPrimaryEmail, subscriptionEditable, fabricatorId) {
        this.setState({ showESignatureOverlay: false });
    }
    function onClick42(showSendResetPasswordPopup, showChangePasswordPopup, user, clientType, handleClosePopup, handleShowPopup, authGoogleCalendar, isEmployee, isCustomer, isFabricator, isMasterFabricator, isStore, isNew, AR, isMaster, canEditFields, canChangePassword, canAddFabricator, paymentProfile, canEditPrimaryEmail, subscriptionEditable, fabricatorId) {
        this.setState({ showPaymentGateways: false });
    }
    function onClick43(showSendResetPasswordPopup, showChangePasswordPopup, user, clientType, handleClosePopup, handleShowPopup, authGoogleCalendar, isEmployee, isCustomer, isFabricator, isMasterFabricator, isStore, isNew, AR, isMaster, canEditFields, canChangePassword, canAddFabricator, paymentProfile, canEditPrimaryEmail, subscriptionEditable, fabricatorId, e) {
        misc.ignoreDefault(e);
    }
    function onClick44(showSendResetPasswordPopup, showChangePasswordPopup, user, clientType, handleClosePopup, handleShowPopup, authGoogleCalendar, isEmployee, isCustomer, isFabricator, isMasterFabricator, isStore, isNew, AR, isMaster, canEditFields, canChangePassword, canAddFabricator, paymentProfile, canEditPrimaryEmail, subscriptionEditable, fabricatorId) {
        this.setState({ paymentGatewayManaging: 'authnet' });
    }
    function onClick45(showSendResetPasswordPopup, showChangePasswordPopup, user, clientType, handleClosePopup, handleShowPopup, authGoogleCalendar, isEmployee, isCustomer, isFabricator, isMasterFabricator, isStore, isNew, AR, isMaster, canEditFields, canChangePassword, canAddFabricator, paymentProfile, canEditPrimaryEmail, subscriptionEditable, fabricatorId) {
        this.setState({ paymentGatewayManaging: 'paypalpro' });
    }
    function onClick46(showSendResetPasswordPopup, showChangePasswordPopup, user, clientType, handleClosePopup, handleShowPopup, authGoogleCalendar, isEmployee, isCustomer, isFabricator, isMasterFabricator, isStore, isNew, AR, isMaster, canEditFields, canChangePassword, canAddFabricator, paymentProfile, canEditPrimaryEmail, subscriptionEditable, fabricatorId) {
        this.setState({ paymentGatewayManaging: 'paypalstd' });
    }
    function onChange47(showSendResetPasswordPopup, showChangePasswordPopup, user, clientType, handleClosePopup, handleShowPopup, authGoogleCalendar, isEmployee, isCustomer, isFabricator, isMasterFabricator, isStore, isNew, AR, isMaster, canEditFields, canChangePassword, canAddFabricator, paymentProfile, canEditPrimaryEmail, subscriptionEditable, fabricatorId, e) {
        this.setState({ 'paymentGateway_AuthNet_ApiLogin': e.target.value });
    }
    function onChange48(showSendResetPasswordPopup, showChangePasswordPopup, user, clientType, handleClosePopup, handleShowPopup, authGoogleCalendar, isEmployee, isCustomer, isFabricator, isMasterFabricator, isStore, isNew, AR, isMaster, canEditFields, canChangePassword, canAddFabricator, paymentProfile, canEditPrimaryEmail, subscriptionEditable, fabricatorId, e) {
        this.setState({ 'paymentGateway_AuthNet_TransactionKey': e.target.value });
    }
    function onChecked49(showSendResetPasswordPopup, showChangePasswordPopup, user, clientType, handleClosePopup, handleShowPopup, authGoogleCalendar, isEmployee, isCustomer, isFabricator, isMasterFabricator, isStore, isNew, AR, isMaster, canEditFields, canChangePassword, canAddFabricator, paymentProfile, canEditPrimaryEmail, subscriptionEditable, fabricatorId, e) {
        this.setState({ paymentGateway_AuthNet_TestMode: !this.state.paymentGateway_AuthNet_TestMode });
    }
    function onClick50(showSendResetPasswordPopup, showChangePasswordPopup, user, clientType, handleClosePopup, handleShowPopup, authGoogleCalendar, isEmployee, isCustomer, isFabricator, isMasterFabricator, isStore, isNew, AR, isMaster, canEditFields, canChangePassword, canAddFabricator, paymentProfile, canEditPrimaryEmail, subscriptionEditable, fabricatorId) {
        this.setState({ showPaymentGateways: false });
    }
    function onClick51(showSendResetPasswordPopup, showChangePasswordPopup, user, clientType, handleClosePopup, handleShowPopup, authGoogleCalendar, isEmployee, isCustomer, isFabricator, isMasterFabricator, isStore, isNew, AR, isMaster, canEditFields, canChangePassword, canAddFabricator, paymentProfile, canEditPrimaryEmail, subscriptionEditable, fabricatorId) {
        this.setState({ showDepositDisclaimer: false });
    }
    function onClick52(showSendResetPasswordPopup, showChangePasswordPopup, user, clientType, handleClosePopup, handleShowPopup, authGoogleCalendar, isEmployee, isCustomer, isFabricator, isMasterFabricator, isStore, isNew, AR, isMaster, canEditFields, canChangePassword, canAddFabricator, paymentProfile, canEditPrimaryEmail, subscriptionEditable, fabricatorId, e) {
        misc.ignoreDefault(e);
    }
    function onClick53(showSendResetPasswordPopup, showChangePasswordPopup, user, clientType, handleClosePopup, handleShowPopup, authGoogleCalendar, isEmployee, isCustomer, isFabricator, isMasterFabricator, isStore, isNew, AR, isMaster, canEditFields, canChangePassword, canAddFabricator, paymentProfile, canEditPrimaryEmail, subscriptionEditable, fabricatorId) {
        this.setState({ showDepositDisclaimer: false });
    }
    function onChange54(showSendResetPasswordPopup, showChangePasswordPopup, user, clientType, handleClosePopup, handleShowPopup, authGoogleCalendar, isEmployee, isCustomer, isFabricator, isMasterFabricator, isStore, isNew, AR, isMaster, canEditFields, canChangePassword, canAddFabricator, paymentProfile, canEditPrimaryEmail, subscriptionEditable, fabricatorId, e) {
        this.setState({ editDepositDisclaimer: e.target.value });
    }
    function onClick55(showSendResetPasswordPopup, showChangePasswordPopup, user, clientType, handleClosePopup, handleShowPopup, authGoogleCalendar, isEmployee, isCustomer, isFabricator, isMasterFabricator, isStore, isNew, AR, isMaster, canEditFields, canChangePassword, canAddFabricator, paymentProfile, canEditPrimaryEmail, subscriptionEditable, fabricatorId) {
        this.setState({
            editDepositDisclaimer: this.state.defaultDepositDisclaimer,
            showDepositDisclaimer: false
        });
    }
    function onClick56(showSendResetPasswordPopup, showChangePasswordPopup, user, clientType, handleClosePopup, handleShowPopup, authGoogleCalendar, isEmployee, isCustomer, isFabricator, isMasterFabricator, isStore, isNew, AR, isMaster, canEditFields, canChangePassword, canAddFabricator, paymentProfile, canEditPrimaryEmail, subscriptionEditable, fabricatorId) {
        this.setState({ editDepositDisclaimer: this.state.defaultDepositDisclaimer });
    }
    function scopeShowSendResetPasswordPopupShowChangePasswordPopupUserClientTypeHandleClosePopupHandleShowPopupAuthGoogleCalendarIsEmployeeIsCustomerIsFabricatorIsMasterFabricatorIsStoreIsNewARIsMasterCanEditFieldsCanChangePasswordCanAddFabricatorPaymentProfileCanEditPrimaryEmailSubscriptionEditableFabricatorId57() {
        var showSendResetPasswordPopup = this.state.showSendResetPasswordPopup;
        var showChangePasswordPopup = this.state.showChangePasswordPopup;
        var user = this.state.user;
        var clientType = this.state.urlOnSave;
        var handleClosePopup = this.handleClosePopup;
        var handleShowPopup = this.handleShowPopup;
        var authGoogleCalendar = this.props.authGoogleCalendar;
        var isEmployee = this.state.isEmployee;
        var isCustomer = this.state.isCustomer;
        var isFabricator = this.state.isFabricator;
        var isMasterFabricator = this.state.isMasterFabricator;
        var isStore = this.state.isStore;
        var isNew = this.state.isNew;
        var AR = this.props.AR;
        var isMaster = this.props.masterProfile.isMaster;
        var canEditFields = this.state.canEditFields;
        var canChangePassword = this.state.canChangePassword;
        var canAddFabricator = this.props.canAddFabricator;
        var paymentProfile = this.props.formValues && this.props.formValues.paymentProfile || {};
        var canEditPrimaryEmail = this.state.canEditPrimaryEmail;
        var subscriptionEditable = this.props.formValues && this.props.formValues.subscriptionEditable;
        var fabricatorId = (this.props.formValues || {}).id;
        return React.createElement('div', {}, React.createElement(Form, { 'onSubmit': this.props.handleSubmit(this.handleSave.bind(this)) }, React.createElement(ResetPasswordPopup, {
            showPopup: showSendResetPasswordPopup,
            popupName: 'resetPassword',
            user: user,
            handleClosePopup: handleClosePopup
        }), React.createElement(ResetPasswordPopup, {
            showPopup: showChangePasswordPopup,
            popupName: 'changePassword',
            user: user,
            handleClosePopup: handleClosePopup
        }), React.createElement(Permissions, {
            showPopup: this.state.showPermissionsEmployeePopup,
            user: user,
            handleClosePopup: handleClosePopup,
            entityType: this.state.entityType
        }), React.createElement(Permissions, {
            showPopup: this.state.showPermissionsFabricatorPopup,
            user: user,
            handleClosePopup: handleClosePopup,
            entityType: 'fabricator'
        }), React.createElement('div', { 'className': 'new-account-flex-container' }, React.createElement('div', { 'className': 'new-account-lir controls' }, React.createElement('div', { 'className': 'new-account-col no-flex' }, React.createElement('div', { 'className': 'new-account-topbar' }, this.state.entityId ? React.createElement('div', {
            'className': 'new-account-topbar__item',
            'key': '3709'
        }, React.createElement('div', { 'className': 'new-account-control-text' }, 'Enable/Disable'), React.createElement(Field, {
            'name': 'enabled',
            'component': formCheckBoxField,
            'onChecked': this.updateCheckBoxField,
            'disabled': this.currentEntityForAR().isEnabledCheckBoxDisabled()
        })) : null, !isMaster && isEmployee ? React.createElement('div', {
            'className': 'new-account-topbar__item',
            'key': '4085'
        }, React.createElement('div', { 'className': 'new-account-control-text' }, 'Licensed Admin'), React.createElement(Field, {
            'name': 'isLicensedAdmin',
            'component': formCheckBoxField,
            'onChecked': this.updateCheckBoxField,
            'disabled': this.currentEntityForAR().isLicensedAdminCheckBoxDisabled()
        })) : null)), React.createElement('div', { 'className': 'new-account-col right no-flex' }, React.createElement('div', { 'className': 'text-right' }, React.createElement('div', { 'className': 'text-left' }, canAddFabricator ? React.createElement('div', {
            'className': 'new-account-control-text',
            'key': '4643'
        }, 'Additional Access') : null, React.createElement('div', { 'className': 'new-account-button-wrapper' }, this.currentEntityForAR().canSeePermissionsButton() ? React.createElement('button', {
            'className': 'ui-button2',
            'type': 'button',
            'onClick': onClick1.bind(this, showSendResetPasswordPopup, showChangePasswordPopup, user, clientType, handleClosePopup, handleShowPopup, authGoogleCalendar, isEmployee, isCustomer, isFabricator, isMasterFabricator, isStore, isNew, AR, isMaster, canEditFields, canChangePassword, canAddFabricator, paymentProfile, canEditPrimaryEmail, subscriptionEditable, fabricatorId),
            'key': '4803'
        }, '\r\n                  PERMISSIONS/ACCESS\r\n                ') : null, canAddFabricator ? React.createElement('button', {
            'className': 'ui-button2',
            'onClick': onClick2.bind(this, showSendResetPasswordPopup, showChangePasswordPopup, user, clientType, handleClosePopup, handleShowPopup, authGoogleCalendar, isEmployee, isCustomer, isFabricator, isMasterFabricator, isStore, isNew, AR, isMaster, canEditFields, canChangePassword, canAddFabricator, paymentProfile, canEditPrimaryEmail, subscriptionEditable, fabricatorId),
            'type': 'button',
            'key': '5064'
        }, '\r\n                  Add Store\r\n                ') : null, this.currentEntityForAR().canSeeAddFabricatorButton() ? React.createElement('button', {
            'className': 'ui-button2',
            'onClick': onClick3.bind(this, showSendResetPasswordPopup, showChangePasswordPopup, user, clientType, handleClosePopup, handleShowPopup, authGoogleCalendar, isEmployee, isCustomer, isFabricator, isMasterFabricator, isStore, isNew, AR, isMaster, canEditFields, canChangePassword, canAddFabricator, paymentProfile, canEditPrimaryEmail, subscriptionEditable, fabricatorId),
            'type': 'button',
            'key': '5278'
        }, '\r\n                  Add Fabricator\r\n                ') : null, this.state.showMasterProfileSelection ? React.createElement('button', {
            'className': 'ui-button2',
            'type': 'button',
            'onClick': onClick4.bind(this, showSendResetPasswordPopup, showChangePasswordPopup, user, clientType, handleClosePopup, handleShowPopup, authGoogleCalendar, isEmployee, isCustomer, isFabricator, isMasterFabricator, isStore, isNew, AR, isMaster, canEditFields, canChangePassword, canAddFabricator, paymentProfile, canEditPrimaryEmail, subscriptionEditable, fabricatorId),
            'key': '5683'
        }, '\r\n                  Master profile\r\n                ') : null))))), React.createElement('div', { 'className': 'new-account-block' }, React.createElement('div', { 'className': 'new-account-block-column new-account-block-column--half' }, React.createElement('div', { 'className': 'new-account-lir title' }, React.createElement('div', { 'className': 'new-account-col title' }, React.createElement('div', {}, isFabricator ? 'Company Information' : 'General Info'))), React.createElement('div', { 'className': 'input' }, React.createElement(Field, {
            'name': 'companyName',
            'component': formField,
            'label': 'Company Name ' + (isFabricator ? '*' : ''),
            'disabled': !canEditFields || !this.state.canEditCompanyName,
            'validate': this.state.canEditCompanyName ? requiredWithLength(3, 100) : undefined
        })), React.createElement('div', { 'className': 'input' }, React.createElement(Field, {
            'name': 'firstName',
            'type': 'text',
            'component': formField,
            'label': 'First Name *',
            'validate': required,
            'disabled': !this.state.canEditName
        })), React.createElement('div', { 'className': 'input' }, React.createElement(Field, {
            'name': 'lastName',
            'component': formField,
            'label': 'Last Name *',
            'validate': required,
            'disabled': !this.state.canEditName
        })), !isEmployee ? React.createElement('div', {
            'className': 'input',
            'key': '7208'
        }, React.createElement(Field, {
            'name': 'phone1',
            'component': formField,
            'label': 'Primary phone *',
            'validate': requiredPhoneValidator,
            'disabled': !canEditFields
        })) : null, !isEmployee ? React.createElement('div', {
            'className': 'input',
            'key': '7448'
        }, React.createElement(Field, {
            'name': 'phone2',
            'component': formField,
            'label': 'Secondary phone',
            'validate': phoneValidator,
            'disabled': !(canEditFields || this.state.canEditPhone2)
        })) : null, !isEmployee ? React.createElement('div', {
            'className': 'input',
            'key': '7710'
        }, React.createElement(Field, {
            'name': 'phone3',
            'component': formField,
            'label': 'Additional phone',
            'validate': phoneValidator,
            'disabled': !canEditFields
        })) : null, React.createElement('div', { 'className': 'input' }, React.createElement(Field, {
            'name': 'primaryEmail',
            'component': formField,
            'label': 'Primary Email *',
            'validate': required,
            'disabled': !canEditPrimaryEmail
        })), !isEmployee ? React.createElement('div', {
            'className': 'input',
            'key': '8163'
        }, React.createElement(Field, {
            'name': 'secondaryEmail',
            'component': formField,
            'label': 'Secondary Email',
            'disabled': !canEditFields
        })) : null, isFabricator ? React.createElement('div', {
            'className': 'input',
            'key': '8377'
        }, React.createElement(Field, {
            'name': 'redirectURL',
            'component': formField,
            'label': 'Redirect URL to your Company Website',
            'disabled': !canEditFields
        })) : null, isFabricator ? React.createElement('div', {
            'id': 'inputContainer',
            'className': 'new-account-block-sub-lir new-account-logo-upload-outter',
            'key': '8610'
        }, React.createElement('h1', {}, 'Upload Company Logo'), React.createElement('input', {
            'className': 'new-account-upload-input',
            'id': 'logo',
            'type': 'file',
            'onChange': onChange5.bind(this, showSendResetPasswordPopup, showChangePasswordPopup, user, clientType, handleClosePopup, handleShowPopup, authGoogleCalendar, isEmployee, isCustomer, isFabricator, isMasterFabricator, isStore, isNew, AR, isMaster, canEditFields, canChangePassword, canAddFabricator, paymentProfile, canEditPrimaryEmail, subscriptionEditable, fabricatorId),
            'disabled': !canEditFields
        }), React.createElement('div', { 'className': classNames('new-account-logo-upload-inner', { 'new-account-logo-upload-inner--with-image': this.props.initialValues.companyLogoURL }) }, React.createElement('img', {
            'ref': 'iconHolder',
            'src': this.props.initialValues.companyLogoURL ? this.props.initialValues.companyLogoURL : null,
            'style': this.getFabricatorImageStyles()
        }))) : null), React.createElement('div', { 'className': 'new-account-block-column new-account-block-column--half new-account-block-column--half_right' }, !isEmployee ? [
            React.createElement('div', {
                'className': 'new-account-lir title',
                'key': '95451'
            }, React.createElement('div', { 'className': 'new-account-block-column new-account-block-column--half title' }, React.createElement('div', {}, 'Billing Information')), isFabricator && canEditFields && this.props.subscriptions.length >= 1 ? React.createElement('div', {
                'className': 'new-account-block-column new-account-block-column--half new-account-block-column--half_right',
                'key': '9803'
            }, React.createElement('a', {
                'className': 'ui-button2 ui-button2--blue',
                'onClick': onClick6.bind(this, showSendResetPasswordPopup, showChangePasswordPopup, user, clientType, handleClosePopup, handleShowPopup, authGoogleCalendar, isEmployee, isCustomer, isFabricator, isMasterFabricator, isStore, isNew, AR, isMaster, canEditFields, canChangePassword, canAddFabricator, paymentProfile, canEditPrimaryEmail, subscriptionEditable, fabricatorId)
            }, '\r\n                  ', this.state.saveCC || paymentProfile.customerProfileId ? 'Update' : 'Add', ' Credit Card\r\n                '), !isNew && paymentProfile ? React.createElement('a', {
                'className': 'ui-button2 ui-button2--green',
                'style': { marginLeft: '5px' },
                'onClick': this.showPaymentGateways,
                'key': '10273'
            }, '\r\n                  Payment Gateways\r\n                ') : null) : null),
            React.createElement('div', {
                'className': 'input',
                'key': '95453'
            }, React.createElement(Field, {
                'name': 'billingAddress.name',
                'component': formField,
                'label': 'Name on Card',
                'disabled': !canEditFields,
                'onChange': onChange7.bind(this, showSendResetPasswordPopup, showChangePasswordPopup, user, clientType, handleClosePopup, handleShowPopup, authGoogleCalendar, isEmployee, isCustomer, isFabricator, isMasterFabricator, isStore, isNew, AR, isMaster, canEditFields, canChangePassword, canAddFabricator, paymentProfile, canEditPrimaryEmail, subscriptionEditable, fabricatorId)
            })),
            React.createElement('div', {
                'className': 'input',
                'key': '95455'
            }, React.createElement(Field, {
                'name': 'billingAddress.address1',
                'component': formField,
                'label': 'Address 1' + (!isCustomer ? '' : ' *'),
                'validate': v => isCustomer ? required(v) : undefined,
                'disabled': !canEditFields
            })),
            React.createElement('div', {
                'className': 'input',
                'key': '95457'
            }, React.createElement(Field, {
                'name': 'billingAddress.address2',
                'component': formField,
                'label': 'Address 2',
                'disabled': !canEditFields
            })),
            React.createElement('div', {
                'className': 'new-account-block-column--third',
                'key': '95459'
            }, React.createElement('div', { 'className': 'input' }, React.createElement(Field, {
                'name': 'billingAddress.city',
                'component': formField,
                'label': 'City' + (!isCustomer ? '' : ' *'),
                'validate': v => isCustomer ? required(v) : undefined,
                'disabled': !canEditFields
            }))),
            React.createElement('div', {
                'className': 'new-account-block-column--third new-account-block-column--third_center',
                'key': '954511'
            }, React.createElement('div', { 'className': 'input' }, React.createElement(Field, {
                'name': 'billingAddress.state',
                'component': formField,
                'label': 'State' + (!isCustomer ? '' : ' *'),
                'validate': v => isCustomer ? required(v) : undefined,
                'disabled': !canEditFields
            }))),
            React.createElement('div', {
                'className': 'new-account-block-column--third new-account-block-column--third_right',
                'key': '954513'
            }, React.createElement('div', { 'className': 'input' }, React.createElement(Field, {
                'name': 'billingAddress.zip',
                'component': formField,
                'label': 'Zip Code' + (!isCustomer ? '' : ' *'),
                'validate': v => isCustomer ? required(v) : undefined,
                'disabled': !canEditFields
            }))),
            React.createElement('div', {
                'className': 'new-account-lir new-account-block-sub-lir title',
                'key': '954515'
            }, React.createElement('div', { 'className': 'new-account-block-column new-account-block-column--half title' }, React.createElement('div', {}, 'Business Address')), React.createElement('div', { 'className': 'new-account-block-column new-account-block-column--half new-account-block-column--half_right checkbox' }, React.createElement(Field, {
                'name': 'billingSameAsShipping',
                'component': formCheckBoxField,
                'disabled': !canEditFields,
                'onChecked': this.updateCheckBoxField,
                'labelEnabled': 'Same as Billing',
                'labelDisabled': 'Same as Billing'
            }))),
            React.createElement('div', {
                'className': 'new-account-col input',
                'key': '954517'
            }, React.createElement(Field, {
                'name': 'shippingAddress.name',
                'component': formField,
                'label': 'Business Name' + (isCustomer ? '' : ' *'),
                'validate': v => !isCustomer ? required(v) : undefined,
                'disabled': !canEditFields
            })),
            React.createElement('div', {
                'className': 'new-account-col input',
                'key': '954519'
            }, React.createElement(Field, {
                'name': 'shippingAddress.address1',
                'component': formField,
                'label': 'Business Address 1' + (isCustomer ? '' : ' *'),
                'validate': v => !isCustomer ? required(v) : undefined,
                'disabled': !canEditFields
            })),
            React.createElement('div', {
                'className': 'new-account-col input',
                'key': '954521'
            }, React.createElement(Field, {
                'name': 'shippingAddress.address2',
                'component': formField,
                'label': 'Business Address 2',
                'disabled': !canEditFields
            })),
            React.createElement('div', {
                'className': 'new-account-block-column--third',
                'key': '954523'
            }, React.createElement('div', { 'className': 'new-account-col input' }, React.createElement(Field, {
                'name': 'shippingAddress.city',
                'component': formField,
                'label': 'City' + (isCustomer ? '' : ' *'),
                'validate': v => !isCustomer ? required(v) : undefined,
                'disabled': !canEditFields
            }))),
            React.createElement('div', {
                'className': 'new-account-block-column--third new-account-block-column--third_center',
                'key': '954525'
            }, React.createElement('div', { 'className': 'new-account-col input right' }, React.createElement(Field, {
                'name': 'shippingAddress.state',
                'component': formField,
                'label': 'State' + (isCustomer ? '' : ' *'),
                'validate': v => !isCustomer ? required(v) : undefined,
                'disabled': !canEditFields
            }))),
            React.createElement('div', {
                'className': 'new-account-block-column--third new-account-block-column--third_right',
                'key': '954527'
            }, React.createElement('div', { 'className': 'new-account-col input right' }, React.createElement(Field, {
                'name': 'shippingAddress.zip',
                'component': formField,
                'label': 'Zip Code' + (isCustomer ? '' : ' *'),
                'validate': v => !isCustomer ? required(v) : undefined,
                'disabled': !canEditFields
            })))
        ] : null)), React.createElement('div', { 'className': 'new-account-lir' }, React.createElement('div', { 'className': 'new-account-col input right' }, React.createElement(Field, {
            'name': 'id',
            'component': hiddenField,
            'label': 'ID Number',
            'disabled': true
        }))), React.createElement('div', { 'className': 'new-account-block' }, React.createElement('div', { 'className': 'new-account-block-column new-account-block-column--half' }, isCustomer ? React.createElement('div', {
            'className': 'flex',
            'key': '15994'
        }, React.createElement('div', { 'className': 'new-account-col align-bottom' }, React.createElement(Dropdown, {
            'id': 'vendorType',
            'values': ['select'],
            'activeValue': 'select',
            'underlineText': 'Vendor type',
            'disabled': true,
            'onChange': onChange8.bind(this, showSendResetPasswordPopup, showChangePasswordPopup, user, clientType, handleClosePopup, handleShowPopup, authGoogleCalendar, isEmployee, isCustomer, isFabricator, isMasterFabricator, isStore, isNew, AR, isMaster, canEditFields, canChangePassword, canAddFabricator, paymentProfile, canEditPrimaryEmail, subscriptionEditable, fabricatorId)
        })), React.createElement('div', { 'className': 'new-account-col edit-icon' }, React.createElement('div', { 'className': 'new-account-edit-icon' })), React.createElement('div', { 'className': 'new-account-col right' }, React.createElement('div', { 'className': 'new-account-text-box-wrapper dropdown' }, React.createElement('input', {
            'id': 'vendorType',
            'disabled': 'true'
        })))) : null, isCustomer ? React.createElement('div', {
            'className': 'flex',
            'key': '16671'
        }, React.createElement('div', { 'className': 'new-account-col align-bottom' }, React.createElement(Dropdown, {
            'id': 'repeatingDiscount',
            'values': ['select'],
            'activeValue': 'select',
            'underlineText': 'Repeating Discount',
            'disabled': true,
            'onChange': onChange9.bind(this, showSendResetPasswordPopup, showChangePasswordPopup, user, clientType, handleClosePopup, handleShowPopup, authGoogleCalendar, isEmployee, isCustomer, isFabricator, isMasterFabricator, isStore, isNew, AR, isMaster, canEditFields, canChangePassword, canAddFabricator, paymentProfile, canEditPrimaryEmail, subscriptionEditable, fabricatorId)
        })), React.createElement('div', { 'className': 'new-account-col edit-icon' }, React.createElement('div', { 'className': 'new-account-edit-icon' }))) : null, isCustomer ? React.createElement('div', {
            'className': 'flex',
            'key': '17146'
        }, React.createElement('div', { 'className': 'new-account-col align-bottom' }, React.createElement(Dropdown, {
            'id': 'pricingProfile',
            'values': ['select'],
            'activeValue': 'select',
            'underlineText': 'Pricing Profile',
            'disabled': true,
            'onChange': onChange10.bind(this, showSendResetPasswordPopup, showChangePasswordPopup, user, clientType, handleClosePopup, handleShowPopup, authGoogleCalendar, isEmployee, isCustomer, isFabricator, isMasterFabricator, isStore, isNew, AR, isMaster, canEditFields, canChangePassword, canAddFabricator, paymentProfile, canEditPrimaryEmail, subscriptionEditable, fabricatorId)
        })), React.createElement('div', { 'className': 'new-account-col edit-icon' }, React.createElement('div', { 'className': 'new-account-edit-icon' }))) : null), React.createElement('div', { 'className': 'new-account-block-column new-account-block-column--half new-account-block-column--half_right' }, isCustomer ? React.createElement('div', {
            'className': 'flex',
            'key': '17748'
        }, React.createElement('div', { 'className': 'new-account-col align-bottom' }, React.createElement(Dropdown, {
            'id': 'salesPerson',
            'values': ['select'],
            'activeValue': 'select',
            'underlineText': 'Salesperson',
            'disabled': true,
            'onChange': onChange11.bind(this, showSendResetPasswordPopup, showChangePasswordPopup, user, clientType, handleClosePopup, handleShowPopup, authGoogleCalendar, isEmployee, isCustomer, isFabricator, isMasterFabricator, isStore, isNew, AR, isMaster, canEditFields, canChangePassword, canAddFabricator, paymentProfile, canEditPrimaryEmail, subscriptionEditable, fabricatorId)
        })), React.createElement('div', { 'className': 'new-account-col edit-icon' }, React.createElement('div', { 'className': 'new-account-edit-icon' })), React.createElement('div', { 'className': 'new-account-col right' }, React.createElement('div', { 'className': 'new-account-text-box-wrapper dropdown' }, React.createElement('input', {
            'id': 'salesPerson',
            'disabled': 'true'
        })))) : null, isCustomer ? React.createElement('div', {
            'className': 'flex',
            'key': '18427'
        }, React.createElement('div', { 'className': 'new-account-col align-bottom' }, React.createElement(Dropdown, {
            'id': 'howDidYouHear',
            'values': ['select'],
            'activeValue': 'select',
            'underlineText': 'How did you hear about us?',
            'disabled': true,
            'onChange': onChange12.bind(this, showSendResetPasswordPopup, showChangePasswordPopup, user, clientType, handleClosePopup, handleShowPopup, authGoogleCalendar, isEmployee, isCustomer, isFabricator, isMasterFabricator, isStore, isNew, AR, isMaster, canEditFields, canChangePassword, canAddFabricator, paymentProfile, canEditPrimaryEmail, subscriptionEditable, fabricatorId)
        })), React.createElement('div', { 'className': 'new-account-col edit-icon' }, React.createElement('div', { 'className': 'new-account-edit-icon' })), React.createElement('div', { 'className': 'new-account-col right' }, React.createElement('div', { 'className': 'new-account-text-box-wrapper dropdown' }, React.createElement('input', {
            'id': 'howDidYouHear',
            'disabled': 'true'
        })))) : null, React.createElement('div', { 'className': 'flex' }, AR.isMe(this.state.entityId) ? React.createElement('div', {
            'className': 'new-account-col right align-center',
            'key': '19198'
        }, React.createElement('div', { 'className': 'new-account-lir wrapper' }, React.createElement('div', {
            'className': 'new-account-button',
            'onClick': onClick13.bind(this, showSendResetPasswordPopup, showChangePasswordPopup, user, clientType, handleClosePopup, handleShowPopup, authGoogleCalendar, isEmployee, isCustomer, isFabricator, isMasterFabricator, isStore, isNew, AR, isMaster, canEditFields, canChangePassword, canAddFabricator, paymentProfile, canEditPrimaryEmail, subscriptionEditable, fabricatorId)
        }, React.createElement('span', { 'className': 'new-account-button-text' }, 'Link to Google Calendar 1')))) : null)))), isFabricator && (AR.v(PARTS.FAB_TOGGLE_BUTTON_DEPOSIT) || AR.isSiteAdmin()) ? React.createElement('div', { 'key': '19664' }, React.createElement('div', { 'className': 'new-account-lir title' }, React.createElement('div', { 'className': 'new-account-block-column new-account-block-column--half title' }, React.createElement('div', {}, 'Deposits and Disclaimers'))), React.createElement('div', { 'className': 'new-account-lir' }, React.createElement(Field, {
            'name': 'enableDeposit',
            'component': formCheckBoxField,
            'onChecked': this.updateCheckBoxField,
            'labelEnabled': 'Enable Deposit',
            'labelDisabled': 'Enable Deposit'
        })), (AR.v(PARTS.FAB_TOGGLE_BUTTON_DEPOSIT) || AR.isSiteAdmin()) && (this.props.formValues && this.props.formValues.enableDeposit) ? React.createElement('div', {
            'className': 'new-account-lir--grouped',
            'key': '20210'
        }, React.createElement('div', { 'className': 'new-account-lir title' }, '\r\n          Enter your deposit percentage below.\r\n        '), React.createElement('div', { 'className': 'new-account-lir' }, React.createElement(Field, {
            'name': 'deposit',
            'component': formField,
            'label': 'Deposit Amount'
        })), React.createElement('div', { 'className': 'new-account-lir' }, React.createElement(Field, {
            'name': 'enableDisclaimer',
            'component': formCheckBoxField,
            'onChecked': this.updateCheckBoxField,
            'labelEnabled': 'Enable Disclaimer',
            'labelDisabled': 'Enable Disclaimer'
        }), this.props.formValues.enableDisclaimer ? React.createElement('div', {
            'style': {
                position: 'absolute',
                marginTop: '50px'
            },
            'key': '20904'
        }, React.createElement('div', {
            'className': 'new-account-password-button',
            'onClick': onClick14.bind(this, showSendResetPasswordPopup, showChangePasswordPopup, user, clientType, handleClosePopup, handleShowPopup, authGoogleCalendar, isEmployee, isCustomer, isFabricator, isMasterFabricator, isStore, isNew, AR, isMaster, canEditFields, canChangePassword, canAddFabricator, paymentProfile, canEditPrimaryEmail, subscriptionEditable, fabricatorId)
        }, '\r\n              Edit Disclaimer Message\r\n            ')) : null)) : null) : null, React.createElement('div', { 'className': 'new-account-lir' }, React.createElement('div', { 'className': 'new-account-col' }, React.createElement('div', { 'className': 'new-account-lir' }, React.createElement('div', { 'className': 'new-account-col input' }, React.createElement(Field, {
            'component': 'formField',
            'name': 'password',
            'label': 'Password'
        })), React.createElement('div', { 'className': 'new-account-col input right' }, React.createElement(Field, {
            'component': 'formField',
            'name': 'confirmPassword',
            'label': 'Confirm Password'
        }))))), isEmployee || isCustomer || canChangePassword ? React.createElement('div', {
            'className': 'new-account-block-column new-account-block-column--half',
            'key': '22233'
        }, !isFabricator && !isNew ? React.createElement('div', {
            'className': 'new-account-col title',
            'key': '22374'
        }, 'Manage Account Password') : null, React.createElement('div', { 'className': 'new-account-col' }, !isNew ? React.createElement('div', {
            'className': 'new-account-password-button',
            'onClick': onClick15.bind(this, showSendResetPasswordPopup, showChangePasswordPopup, user, clientType, handleClosePopup, handleShowPopup, authGoogleCalendar, isEmployee, isCustomer, isFabricator, isMasterFabricator, isStore, isNew, AR, isMaster, canEditFields, canChangePassword, canAddFabricator, paymentProfile, canEditPrimaryEmail, subscriptionEditable, fabricatorId),
            'key': '22519'
        }, '\r\n          Send Reset Password Email\r\n        ') : null, !isNew && !isCustomer || canChangePassword ? React.createElement('div', {
            'className': 'new-account-password-button right',
            'onClick': onClick16.bind(this, showSendResetPasswordPopup, showChangePasswordPopup, user, clientType, handleClosePopup, handleShowPopup, authGoogleCalendar, isEmployee, isCustomer, isFabricator, isMasterFabricator, isStore, isNew, AR, isMaster, canEditFields, canChangePassword, canAddFabricator, paymentProfile, canEditPrimaryEmail, subscriptionEditable, fabricatorId),
            'key': '22687'
        }, '\r\n          Change Password\r\n        ') : null)) : null, isFabricator ? scopeShowBV23.apply(this, [
            showSendResetPasswordPopup,
            showChangePasswordPopup,
            user,
            clientType,
            handleClosePopup,
            handleShowPopup,
            authGoogleCalendar,
            isEmployee,
            isCustomer,
            isFabricator,
            isMasterFabricator,
            isStore,
            isNew,
            AR,
            isMaster,
            canEditFields,
            canChangePassword,
            canAddFabricator,
            paymentProfile,
            canEditPrimaryEmail,
            subscriptionEditable,
            fabricatorId
        ]) : null, React.createElement('div', { 'className': 'new-account-block new-account-block-column' }, React.createElement('div', { 'className': 'new-account-block-sub-lir' }, React.createElement('div', { 'className': 'new-accouunt-block-column new-account-block-column--half separator-bottom' }), React.createElement('div', { 'className': 'new-accouunt-block-column new-account-block-column--half new-account-block-column--half_right separator-bottom' }))), isFabricator ? React.createElement('div', {
            'className': 'new-account-block new-account-block-column new-account-block-column--twothirds new-account-block-column--center',
            'key': '38527'
        }, [
            React.createElement('h3', { 'key': '386911' }, 'Visualizer props'),
            React.createElement('div', {
                'className': 'new-account-block-column',
                'key': '386913'
            }, AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_SHOW_PRICING) ? React.createElement(Field, {
                'name': 'showPricing',
                'component': formCheckBoxField,
                'onChecked': this.updateCheckBoxField,
                'labelEnabled': 'Show Pricing Visualizer',
                'labelDisabled': 'Show Pricing Visualizer',
                'disabled': AR.d(PARTS.FAB_TOGGLE_BUTTON_BV_SHOW_PRICING) || !this.props.formValues,
                'key': '38798'
            }) : null),
            React.createElement('div', {
                'className': 'new-account-block-column',
                'key': '386915'
            }, AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_CHECKOUT) ? React.createElement(Field, {
                'name': 'checkOut',
                'component': formCheckBoxField,
                'onChecked': this.updateCheckBoxField,
                'labelEnabled': 'CheckOut',
                'labelDisabled': 'CheckOut',
                'disabled': AR.d(PARTS.FAB_TOGGLE_BUTTON_BV_CHECKOUT) || !this.props.formValues || !this.props.formValues.showPricing,
                'key': '39240'
            }) : null),
            React.createElement('div', {
                'className': 'new-account-block-column new-account-block-column--half',
                'key': '386917'
            }, AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_ADD_LABOR_CUSTOMER) ? React.createElement(Field, {
                'name': 'addLaborCustomer',
                'component': formCheckBoxField,
                'onChecked': this.updateCheckBoxField,
                'labelEnabled': 'Add Labor Customer',
                'labelDisabled': 'Add Labor Customer',
                'disabled': AR.d(PARTS.FAB_TOGGLE_BUTTON_BV_ADD_LABOR_CUSTOMER),
                'key': '39710'
            }) : null),
            React.createElement('div', {
                'className': 'new-account-block-column new-account-block-column--half new-account-block-column--half_right',
                'key': '386919'
            }, AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_ADD_LABOR_INSTALLER) ? React.createElement(Field, {
                'name': 'addLaborInstaller',
                'component': formCheckBoxField,
                'onChecked': this.updateCheckBoxField,
                'labelEnabled': 'Add Labor Installer',
                'labelDisabled': 'Add Labor Installer',
                'disabled': AR.d(PARTS.FAB_TOGGLE_BUTTON_BV_ADD_LABOR_INSTALLER),
                'key': '40213'
            }) : null),
            React.createElement('div', {
                'className': 'new-account-block-column',
                'key': '3869111'
            }, AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_SEPARATE_LABOR_IN_CART) ? React.createElement(Field, {
                'name': 'separateLaborInCart',
                'component': formCheckBoxField,
                'onChecked': this.updateCheckBoxField,
                'labelEnabled': 'Separate Labor in Cart',
                'labelDisabled': 'Separate Labor in Cart',
                'disabled': AR.d(PARTS.FAB_TOGGLE_BUTTON_BV_SEPARATE_LABOR_IN_CART) || !this.props.formValues || !this.props.formValues.showPricing,
                'key': '40641'
            }) : null),
            React.createElement('div', {
                'className': 'new-account-block-column',
                'key': '3869113'
            }, AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_ENABLE_SHARING) ? React.createElement(Field, {
                'name': 'enableSharing',
                'component': formCheckBoxField,
                'onChecked': this.updateCheckBoxField,
                'labelEnabled': 'Enable Sharing',
                'labelDisabled': 'Enable Sharing',
                'disabled': AR.d(PARTS.FAB_TOGGLE_BUTTON_BV_ENABLE_SHARING),
                'key': '41147'
            }) : null),
            React.createElement('div', {
                'className': 'new-account-block-column new-account-block-column--half',
                'key': '3869115'
            }, AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_WIZARD_CONSUMERS) ? React.createElement(Field, {
                'name': 'wizardConsumers',
                'component': formCheckBoxField,
                'onChecked': this.updateCheckBoxField,
                'labelEnabled': 'Wizard Consumers',
                'labelDisabled': 'Wizard Consumers',
                'disabled': AR.d(PARTS.FAB_TOGGLE_BUTTON_BV_WIZARD_CONSUMERS),
                'key': '41582'
            }) : null),
            React.createElement('div', {
                'className': 'new-account-block-column new-account-block-column--half new-account-block-column--half_right',
                'key': '3869117'
            }, AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_WIZARD_DASHBOARD) ? React.createElement(Field, {
                'name': 'wizardClients',
                'component': formCheckBoxField,
                'onChecked': this.updateCheckBoxField,
                'labelEnabled': 'Wizard Dashboard',
                'labelDisabled': 'Wizard Dashboard',
                'disabled': AR.d(PARTS.FAB_TOGGLE_BUTTON_BV_WIZARD_DASHBOARD),
                'key': '42064'
            }) : null),
            React.createElement('div', {
                'className': 'new-account-block-column new-account-block-column--half',
                'key': '3869119'
            }, AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_2_FACTOR_CONSUMERS) ? React.createElement(Field, {
                'name': 'twoFA',
                'component': formCheckBoxField,
                'onChecked': this.updateCheckBoxField,
                'labelEnabled': '2 Factor Consumers',
                'labelDisabled': '2 Factor Consumers',
                'disabled': AR.d(PARTS.FAB_TOGGLE_BUTTON_BV_2_FACTOR_CONSUMERS) || !this.props.formValues || !this.props.formValues.leadCapture && !this.props.formValues.clickLeadCapture && !this.props.formValues.twoFA,
                'key': '42507'
            }) : null),
            React.createElement('div', {
                'className': 'new-account-block-column new-account-block-column--half new-account-block-column--half_right',
                'key': '3869121'
            }, AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_2_FACTOR_DASHBOARD) ? React.createElement(Field, {
                'name': 'twoFADashboard',
                'component': formCheckBoxField,
                'onChecked': this.updateCheckBoxField,
                'labelEnabled': '2 Factor Dashboard',
                'labelDisabled': '2 Factor Dashboard',
                'disabled': AR.d(PARTS.FAB_TOGGLE_BUTTON_BV_2_FACTOR_DASHBOARD) || !this.props.formValues || !this.props.formValues.leadCaptureDashboard && !this.props.formValues.clickLeadCaptureDashboard && !this.props.formValues.twoFADashboard,
                'key': '43128'
            }) : null),
            React.createElement('div', {
                'className': 'new-account-block-column new-account-block-column--half',
                'key': '3869123'
            }, AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_LEAD_CAPTURE_CONSUMERS) ? React.createElement(Field, {
                'name': 'leadCapture',
                'component': formCheckBoxField,
                'onChecked': this.updateCheckBoxField,
                'labelEnabled': 'Lead Capture Visualizer',
                'labelDisabled': 'Lead Capture Visualizer',
                'disabled': AR.d(PARTS.FAB_TOGGLE_BUTTON_BV_LEAD_CAPTURE_CONSUMERS),
                'key': '43748'
            }) : null),
            React.createElement('div', {
                'className': 'new-account-block-column new-account-block-column--half new-account-block-column--half_right',
                'key': '3869125'
            }, AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_LEAD_CAPTURE_DASHBOARD) ? React.createElement(Field, {
                'name': 'leadCaptureDashboard',
                'component': formCheckBoxField,
                'onChecked': this.updateCheckBoxField,
                'labelEnabled': 'Lead Capture Dashboard',
                'labelDisabled': 'Lead Capture Dashboard',
                'disabled': AR.d(PARTS.FAB_TOGGLE_BUTTON_BV_LEAD_CAPTURE_DASHBOARD) || !this.props.formValues || this.props.formValues.clickLeadCaptureDashboard && !this.props.formValues.leadCaptureDashboard,
                'key': '44252'
            }) : null),
            React.createElement('div', {
                'className': 'new-account-block-column new-account-block-column--half',
                'key': '3869127'
            }, AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_CLICK_TO_LEAD_CAPTURE) ? React.createElement(Field, {
                'name': 'clickLeadCapture',
                'component': formCheckBoxField,
                'onChecked': this.updateCheckBoxField,
                'labelEnabled': 'Click to Lead Capture Visualizer',
                'labelDisabled': 'Click to Lead Capture Visualizer',
                'disabled': AR.d(PARTS.FAB_TOGGLE_BUTTON_BV_CLICK_TO_LEAD_CAPTURE),
                'key': '44852'
            }) : null),
            React.createElement('div', {
                'className': 'new-account-block-column new-account-block-column--half new-account-block-column--half_right',
                'key': '3869129'
            }, AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_CLICK_TO_LEAD_CAPTURE_DASHBOARD) ? React.createElement(Field, {
                'name': 'clickLeadCaptureDashboard',
                'component': formCheckBoxField,
                'onChecked': this.updateCheckBoxField,
                'labelEnabled': 'Click to Lead Capture (from Dashboard)',
                'labelDisabled': 'Click to Lead Capture (from Dashboard)',
                'disabled': AR.d(PARTS.FAB_TOGGLE_BUTTON_BV_CLICK_TO_LEAD_CAPTURE_DASHBOARD) || !this.props.formValues || this.props.formValues.leadCaptureDashboard && !this.props.formValues.clickLeadCaptureDashboard,
                'key': '45377'
            }) : null),
            React.createElement('div', {
                'className': 'new-account-block-column',
                'key': '3869131'
            }, this.props.formValues && (AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_CLICK_TO_LEAD_CAPTURE) && this.props.formValues.clickLeadCapture || AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_CLICK_TO_LEAD_CAPTURE_DASHBOARD) && this.props.formValues.clickLeadCaptureDashboard) ? React.createElement(Field, {
                'name': 'clickLeadCount',
                'component': formField,
                'label': 'Click Count to Lead Capture Visualizer',
                'type': 'text',
                'key': '46019'
            }) : null),
            React.createElement('div', {
                'className': 'new-account-block-column new-account-block-column--half',
                'key': '3869133'
            }, AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_LEAD_CAPTURE_CONSUMERS) ? React.createElement(Field, {
                'name': 'leadCaptureOnQuote',
                'component': formCheckBoxField,
                'onChecked': this.updateCheckBoxField,
                'labelEnabled': 'Lead Capture Consumers on Quote',
                'labelDisabled': 'Lead Capture Consumers on Quote',
                'disabled': AR.d(PARTS.FAB_TOGGLE_BUTTON_BV_LEAD_CAPTURE_CONSUMERS),
                'key': '46555'
            }) : null),
            React.createElement('div', {
                'className': 'new-account-block-column new-account-block-column--half new-account-block-column--half_right',
                'key': '3869135'
            }),
            React.createElement('div', {
                'className': 'new-account-block-column new-account-block-column--half',
                'key': '3869137'
            }, AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_CLICK_TO_LEAD_CAPTURE) ? React.createElement(Field, {
                'name': 'clickLeadCaptureOnQuote',
                'component': formCheckBoxField,
                'onChecked': this.updateCheckBoxField,
                'labelEnabled': 'Click to Lead Capture On Quote',
                'labelDisabled': 'Click to Lead Capture On Quote',
                'disabled': AR.d(PARTS.FAB_TOGGLE_BUTTON_BV_CLICK_TO_LEAD_CAPTURE),
                'key': '47167'
            }) : null),
            React.createElement('div', {
                'className': 'new-account-block-column new-account-block-column--half new-account-block-column--half_right',
                'key': '3869139'
            }),
            React.createElement('div', {
                'className': 'new-account-block-column',
                'key': '3869141'
            }, this.props.formValues && (AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_CLICK_TO_LEAD_CAPTURE) && this.props.formValues.clickLeadCaptureOnQuote || AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_CLICK_TO_LEAD_CAPTURE_DASHBOARD) && this.props.formValues.clickLeadCaptureDashboard) ? React.createElement(Field, {
                'name': 'clickLeadCountOnQuote',
                'component': formField,
                'label': 'Click Count to Lead Capture On Quote',
                'type': 'text',
                'key': '47749'
            }) : null),
            React.createElement('div', {
                'className': 'new-account-block-column new-account-block-column--half',
                'key': '3869143'
            }, AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_ENABLE_GET_QUOTE) ? React.createElement(Field, {
                'name': 'enableQuote',
                'component': formCheckBoxField,
                'onChecked': this.updateCheckBoxField,
                'labelEnabled': 'Enable Get Quote',
                'labelDisabled': 'Enable Get Quote',
                'disabled': AR.d(PARTS.FAB_TOGGLE_BUTTON_BV_ENABLE_GET_QUOTE) || !this.props.formValues,
                'key': '48297'
            }) : null),
            React.createElement('div', {
                'className': 'new-account-block-column new-account-block-column--half new-account-block-column--half_right',
                'key': '3869145'
            }, AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_ENABLE_GET_QUOTE_DASHBOARD) ? React.createElement(Field, {
                'name': 'enableQuoteDashboard',
                'component': formCheckBoxField,
                'onChecked': this.updateCheckBoxField,
                'labelEnabled': 'Enable Get Quote (from Dashboard)',
                'labelDisabled': 'Enable Get Quote (from Dashboard)',
                'disabled': AR.d(PARTS.FAB_TOGGLE_BUTTON_BV_ENABLE_GET_QUOTE_DASHBOARD) || !this.props.formValues,
                'key': '48801'
            }) : null),
            React.createElement('div', {
                'className': 'new-account-block-column new-account-block-column--half',
                'key': '3869147'
            }, AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_ENABLE_SCHEDULING) ? React.createElement(Field, {
                'name': 'enableScheduling',
                'component': formCheckBoxField,
                'onChecked': this.updateCheckBoxField,
                'labelEnabled': 'Enable Scheduling',
                'labelDisabled': 'Enable Scheduling',
                'disabled': AR.d(PARTS.FAB_TOGGLE_BUTTON_BV_ENABLE_SCHEDULING),
                'key': '49331'
            }) : null),
            React.createElement('div', {
                'className': 'new-account-block-column new-account-block-column--half new-account-block-column--half_right',
                'key': '3869149'
            }, AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_ENABLE_SCHEDULING_DASHBOARD) ? React.createElement(Field, {
                'name': 'enableSchedulingDashboard',
                'component': formCheckBoxField,
                'onChecked': this.updateCheckBoxField,
                'labelEnabled': 'Enable Scheduling (from Dashboard)',
                'labelDisabled': 'Enable Scheduling (from Dashboard)',
                'disabled': AR.d(PARTS.FAB_TOGGLE_BUTTON_BV_ENABLE_SCHEDULING_DASHBOARD),
                'key': '49818'
            }) : null),
            React.createElement('div', {
                'className': 'new-account-block-column',
                'key': '3869151'
            }, AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_VISUALIZER_ONLY) ? React.createElement(Field, {
                'name': 'visualizerOnly',
                'component': formCheckBoxField,
                'onChecked': this.updateCheckBoxField,
                'labelEnabled': 'Visualizer Only',
                'labelDisabled': 'Visualizer Only',
                'disabled': AR.d(PARTS.FAB_TOGGLE_BUTTON_BV_VISUALIZER_ONLY),
                'key': '50318'
            }) : null),
            React.createElement('div', {
                'className': 'new-account-block-column new-account-block-column--half',
                'key': '3869153'
            }, AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_SHOW_SMALL_BV_DESIGN_CONSUMERS) ? React.createElement(Field, {
                'name': 'showSmallBathroomDesignForClients',
                'component': formCheckBoxField,
                'onChecked': this.updateCheckBoxField,
                'labelEnabled': 'Show Small Bathroom Design For Consumers',
                'labelDisabled': 'Show Small Bathroom Design For Consumers',
                'disabled': AR.d(PARTS.FAB_TOGGLE_BUTTON_BV_SHOW_SMALL_BV_DESIGN_CONSUMERS),
                'key': '50758'
            }) : null),
            React.createElement('div', {
                'className': 'new-account-block-column new-account-block-column--half new-account-block-column--half_right',
                'key': '3869155'
            }, AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_SHOW_SMALL_BV_DESIGN_DASHBOARD) ? React.createElement(Field, {
                'name': 'showSmallBathroomDesignFromDashboard',
                'component': formCheckBoxField,
                'onChecked': this.updateCheckBoxField,
                'labelEnabled': 'Show Small Bathroom Design From Dashboard',
                'labelDisabled': 'Show Small Bathroom Design From Dashboard',
                'disabled': AR.d(PARTS.FAB_TOGGLE_BUTTON_BV_SHOW_SMALL_BV_DESIGN_DASHBOARD),
                'key': '51370'
            }) : null),
            React.createElement('div', {
                'className': 'new-account-block-column new-account-block-column--half',
                'key': '3869157'
            }, AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_YES_NO_CONSULTATION) ? React.createElement(Field, {
                'name': 'yesNoConsultationRequest',
                'component': formCheckBoxField,
                'onChecked': this.updateCheckBoxField,
                'labelEnabled': 'Yes/No Consultation Request',
                'labelDisabled': 'Yes/No Consultation Request',
                'disabled': AR.d(PARTS.FAB_TOGGLE_BUTTON_BV_YES_NO_CONSULTATION),
                'key': '51950'
            }) : null),
            React.createElement('div', {
                'className': 'new-account-block-column new-account-block-column--half new-account-block-column--half_right',
                'key': '3869159'
            }, AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_ENABLE_CALENDAR_FOR_SCHEDULING) ? React.createElement(Field, {
                'name': 'enableCalendarForScheduling',
                'component': formCheckBoxField,
                'onChecked': this.updateCheckBoxField,
                'labelEnabled': 'Enable Calendar for Scheduling',
                'labelDisabled': 'Enable Calendar for Scheduling',
                'disabled': AR.d(PARTS.FAB_TOGGLE_BUTTON_BV_ENABLE_CALENDAR_FOR_SCHEDULING),
                'key': '52469'
            }) : null),
            this.props.formValues && (this.props.formValues.yesNoConsultationRequest && AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_YES_NO_CONSULTATION)) ? React.createElement('div', {
                'className': 'new-account-block-column',
                'key': '3869161'
            }, React.createElement('div', {}, React.createElement(Field, {
                'name': 'noCallFabricatorId',
                'component': hiddenField
            }), React.createElement(Field, {
                'name': 'noCallFabricatorName',
                'component': formField,
                'label': 'No Call Fabricator',
                'type': 'text',
                'disabled': true
            })), React.createElement('button', {
                'className': 'ui-button2 ui-button2--blue',
                'onClick': onClick24.bind(this, showSendResetPasswordPopup, showChangePasswordPopup, user, clientType, handleClosePopup, handleShowPopup, authGoogleCalendar, isEmployee, isCustomer, isFabricator, isMasterFabricator, isStore, isNew, AR, isMaster, canEditFields, canChangePassword, canAddFabricator, paymentProfile, canEditPrimaryEmail, subscriptionEditable, fabricatorId),
                'type': 'button'
            }, 'Change\r\n          ')) : null,
            React.createElement('div', {
                'className': 'new-account-block-column new-account-block-column--half',
                'key': '3869163'
            }, AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_AUTO_CALL_FABRICATOR_LEAD) ? React.createElement(Field, {
                'name': 'enableFabricatorAutoCall',
                'component': formCheckBoxField,
                'onChecked': this.updateCheckBoxField,
                'labelEnabled': 'Auto-Call Fabricator with New Lead',
                'labelDisabled': 'Auto-Call Fabricator with New Lead',
                'disabled': AR.d(PARTS.FAB_TOGGLE_BUTTON_BV_AUTO_CALL_FABRICATOR_LEAD),
                'key': '53700'
            }) : null),
            React.createElement('div', {
                'className': 'new-account-block-column new-account-block-column--half new-account-block-column--half_right',
                'key': '3869165'
            }, AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_AUTO_CALL_FABRICATOR_FROM_DASHBOARD) ? React.createElement(Field, {
                'name': 'enableFabricatorAutoCallDashboard',
                'component': formCheckBoxField,
                'onChecked': this.updateCheckBoxField,
                'labelEnabled': 'Auto-Call with New Lead From Dashboard',
                'labelDisabled': 'Auto-Call with New Lead From Dashboard',
                'disabled': AR.d(PARTS.FAB_TOGGLE_BUTTON_BV_AUTO_CALL_FABRICATOR_FROM_DASHBOARD),
                'key': '54263'
            }) : null),
            React.createElement('div', {
                'className': 'new-account-block-column new-account-block-column--half',
                'key': '3869167'
            }, React.createElement(Field, {
                'name': 'enableCookiePopup',
                'component': formCheckBoxField,
                'onChecked': this.updateCheckBoxField,
                'labelEnabled': 'Enable Cookie Popup',
                'labelDisabled': 'Enable Cookie Popup'
            })),
            React.createElement('div', {
                'className': 'new-account-block-column new-account-block-column--half',
                'key': '3869169'
            }),
            React.createElement('div', {
                'className': 'new-account-block-column new-account-block-column--half',
                'key': '3869171'
            }, React.createElement(Field, {
                'name': 'enableSqFt',
                'component': formCheckBoxField,
                'onChecked': this.updateCheckBoxField,
                'labelEnabled': 'Disable SQFT',
                'labelDisabled': 'Disable SQFT'
            })),
            React.createElement('div', {
                'className': 'new-account-block-column new-account-block-column--half',
                'key': '3869173'
            }),
            React.createElement('div', {
                'className': 'new-account-block-column new-account-block-column--half',
                'key': '3869175'
            }, React.createElement(Field, {
                'name': 'leadCaptureShoppingCart',
                'component': formCheckBoxField,
                'onChecked': this.updateCheckBoxField,
                'labelEnabled': 'Lead Capture Shopping Cart',
                'labelDisabled': 'Lead Capture Shopping Cart'
            })),
            React.createElement('div', {
                'className': 'new-account-block-column new-account-block-column--half',
                'key': '3869177'
            }, React.createElement(Field, {
                'name': 'leadCaptureShoppingCartDashboard',
                'component': formCheckBoxField,
                'onChecked': this.updateCheckBoxField,
                'labelEnabled': 'Lead Capture Shopping Cart (Dashboard)',
                'labelDisabled': 'Lead Capture Shopping Cart (Dashboard)'
            })),
            React.createElement('div', {
                'className': 'new-account-block-column new-account-block-column--half',
                'key': '3869179'
            }, React.createElement(Field, {
                'name': 'showRecentlyViewedItems',
                'component': formCheckBoxField,
                'onChecked': this.updateCheckBoxField,
                'labelEnabled': 'Show Recently Viewed Items',
                'labelDisabled': 'Show Recently Viewed Items'
            })),
            React.createElement('div', {
                'className': 'new-account-block-column new-account-block-column--half',
                'key': '3869181'
            }),
            React.createElement('div', {
                'className': 'new-account-block-column new-account-block-column--half',
                'style': {
                    marginTop: '10px',
                    paddingTop: '10px',
                    borderTop: '1px solid #4A90E2'
                },
                'key': '3869183'
            }, React.createElement(Dropdown, {
                'id': 'currencyDropdown',
                'values': [
                    'USD',
                    'EUR',
                    'GBP'
                ],
                'activeValue': this.state.activeCurrency,
                'underlineText': 'Select currency',
                'onChange': onChange25.bind(this, showSendResetPasswordPopup, showChangePasswordPopup, user, clientType, handleClosePopup, handleShowPopup, authGoogleCalendar, isEmployee, isCustomer, isFabricator, isMasterFabricator, isStore, isNew, AR, isMaster, canEditFields, canChangePassword, canAddFabricator, paymentProfile, canEditPrimaryEmail, subscriptionEditable, fabricatorId)
            })),
            ,
            React.createElement('div', {
                'className': 'new-account-block new-account-block-column',
                'key': '3869187'
            }, React.createElement('div', { 'className': 'new-account-block-sub-lir' }, React.createElement('div', { 'className': 'new-accouunt-block-column new-account-block-column--half separator-bottom' }), React.createElement('div', { 'className': 'new-accouunt-block-column new-account-block-column--half new-account-block-column--half_right separator-bottom' }))),
            React.createElement('h3', { 'key': '3869189' }, 'Kitchen props'),
            React.createElement('div', {
                'className': 'new-account-block-column',
                'key': '3869191'
            }, AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_SHOW_PRICING) ? React.createElement(Field, {
                'name': 'showPricingKitchen',
                'component': formCheckBoxField,
                'onChecked': this.updateCheckBoxField,
                'labelEnabled': 'Show Pricing Visualizer',
                'labelDisabled': 'Show Pricing Visualizer',
                'disabled': AR.d(PARTS.FAB_TOGGLE_BUTTON_BV_SHOW_PRICING) || !this.props.formValues,
                'key': '57676'
            }) : null),
            React.createElement('div', {
                'className': 'new-account-block-column',
                'key': '3869193'
            }, AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_CHECKOUT) ? React.createElement(Field, {
                'name': 'checkOutKitchen',
                'component': formCheckBoxField,
                'onChecked': this.updateCheckBoxField,
                'labelEnabled': 'CheckOut',
                'labelDisabled': 'CheckOut',
                'disabled': AR.d(PARTS.FAB_TOGGLE_BUTTON_BV_CHECKOUT) || !this.props.formValues || !this.props.formValues.showPricingKitchen,
                'key': '58125'
            }) : null),
            React.createElement('div', {
                'className': 'new-account-block-column new-account-block-column--half',
                'key': '3869195'
            }, AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_ADD_LABOR_CUSTOMER) ? React.createElement(Field, {
                'name': 'addLaborCustomerKitchen',
                'component': formCheckBoxField,
                'onChecked': this.updateCheckBoxField,
                'labelEnabled': 'Add Labor Customer',
                'labelDisabled': 'Add Labor Customer',
                'disabled': AR.d(PARTS.FAB_TOGGLE_BUTTON_BV_ADD_LABOR_CUSTOMER),
                'key': '58609'
            }) : null),
            React.createElement('div', {
                'className': 'new-account-block-column new-account-block-column--half new-account-block-column--half_right',
                'key': '3869197'
            }, AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_ADD_LABOR_INSTALLER) ? React.createElement(Field, {
                'name': 'addLaborInstallerKitchen',
                'component': formCheckBoxField,
                'onChecked': this.updateCheckBoxField,
                'labelEnabled': 'Add Labor Installer',
                'labelDisabled': 'Add Labor Installer',
                'disabled': AR.d(PARTS.FAB_TOGGLE_BUTTON_BV_ADD_LABOR_INSTALLER),
                'key': '59119'
            }) : null),
            React.createElement('div', {
                'className': 'new-account-block-column',
                'key': '3869199'
            }, AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_SEPARATE_LABOR_IN_CART) ? React.createElement(Field, {
                'name': 'separateLaborInCartKitchen',
                'component': formCheckBoxField,
                'onChecked': this.updateCheckBoxField,
                'labelEnabled': 'Separate Labor in Cart',
                'labelDisabled': 'Separate Labor in Cart',
                'disabled': AR.d(PARTS.FAB_TOGGLE_BUTTON_BV_SEPARATE_LABOR_IN_CART) || !this.props.formValues || !this.props.formValues.showPricingKitchen,
                'key': '59554'
            }) : null),
            React.createElement('div', {
                'className': 'new-account-block-column',
                'key': '38691101'
            }, AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_ENABLE_SHARING) ? React.createElement(Field, {
                'name': 'enableSharingKitchen',
                'component': formCheckBoxField,
                'onChecked': this.updateCheckBoxField,
                'labelEnabled': 'Enable Sharing',
                'labelDisabled': 'Enable Sharing',
                'disabled': AR.d(PARTS.FAB_TOGGLE_BUTTON_BV_ENABLE_SHARING),
                'key': '60074'
            }) : null),
            React.createElement('div', {
                'className': 'new-account-block-column new-account-block-column--half',
                'key': '38691103'
            }, AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_WIZARD_CONSUMERS) ? React.createElement(Field, {
                'name': 'wizardConsumersKitchen',
                'component': formCheckBoxField,
                'onChecked': this.updateCheckBoxField,
                'labelEnabled': 'Wizard Consumers',
                'labelDisabled': 'Wizard Consumers',
                'disabled': AR.d(PARTS.FAB_TOGGLE_BUTTON_BV_WIZARD_CONSUMERS),
                'key': '60516'
            }) : null),
            React.createElement('div', {
                'className': 'new-account-block-column new-account-block-column--half new-account-block-column--half_right',
                'key': '38691105'
            }, AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_WIZARD_DASHBOARD) ? React.createElement(Field, {
                'name': 'wizardClientsKitchen',
                'component': formCheckBoxField,
                'onChecked': this.updateCheckBoxField,
                'labelEnabled': 'Wizard Dashboard',
                'labelDisabled': 'Wizard Dashboard',
                'disabled': AR.d(PARTS.FAB_TOGGLE_BUTTON_BV_WIZARD_DASHBOARD),
                'key': '61005'
            }) : null),
            React.createElement('div', {
                'className': 'new-account-block-column new-account-block-column--half',
                'key': '38691107'
            }, AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_2_FACTOR_CONSUMERS) ? React.createElement(Field, {
                'name': 'twoFAKitchen',
                'component': formCheckBoxField,
                'onChecked': this.updateCheckBoxField,
                'labelEnabled': '2 Factor Consumers',
                'labelDisabled': '2 Factor Consumers',
                'disabled': AR.d(PARTS.FAB_TOGGLE_BUTTON_BV_2_FACTOR_CONSUMERS) || !this.props.formValues || !this.props.formValues.leadCaptureKitchen && !this.props.formValues.clickLeadCaptureKitchen && !this.props.formValues.twoFAKitchen,
                'key': '61455'
            }) : null),
            React.createElement('div', {
                'className': 'new-account-block-column new-account-block-column--half new-account-block-column--half_right',
                'key': '38691109'
            }, AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_2_FACTOR_DASHBOARD) ? React.createElement(Field, {
                'name': 'twoFADashboardKitchen',
                'component': formCheckBoxField,
                'onChecked': this.updateCheckBoxField,
                'labelEnabled': '2 Factor Dashboard',
                'labelDisabled': '2 Factor Dashboard',
                'disabled': AR.d(PARTS.FAB_TOGGLE_BUTTON_BV_2_FACTOR_DASHBOARD) || !this.props.formValues || !this.props.formValues.leadCaptureDashboardKitchen && !this.props.formValues.clickLeadCaptureDashboardKitchen && !this.props.formValues.twoFADashboardKitchen,
                'key': '62104'
            }) : null),
            React.createElement('div', {
                'className': 'new-account-block-column new-account-block-column--half',
                'key': '38691111'
            }, AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_LEAD_CAPTURE_CONSUMERS) ? React.createElement(Field, {
                'name': 'leadCaptureKitchen',
                'component': formCheckBoxField,
                'onChecked': this.updateCheckBoxField,
                'labelEnabled': 'Lead Capture Visualizer',
                'labelDisabled': 'Lead Capture Visualizer',
                'disabled': AR.d(PARTS.FAB_TOGGLE_BUTTON_BV_LEAD_CAPTURE_CONSUMERS),
                'key': '62752'
            }) : null),
            React.createElement('div', {
                'className': 'new-account-block-column new-account-block-column--half new-account-block-column--half_right',
                'key': '38691113'
            }, AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_LEAD_CAPTURE_DASHBOARD) ? React.createElement(Field, {
                'name': 'leadCaptureDashboardKitchen',
                'component': formCheckBoxField,
                'onChecked': this.updateCheckBoxField,
                'labelEnabled': 'Lead Capture Dashboard',
                'labelDisabled': 'Lead Capture Dashboard',
                'disabled': AR.d(PARTS.FAB_TOGGLE_BUTTON_BV_LEAD_CAPTURE_DASHBOARD) || !this.props.formValues || this.props.formValues.clickLeadCaptureDashboardKitchen && !this.props.formValues.leadCaptureDashboardKitchen,
                'key': '63263'
            }) : null),
            React.createElement('div', {
                'className': 'new-account-block-column new-account-block-column--half',
                'key': '38691115'
            }, AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_CLICK_TO_LEAD_CAPTURE) ? React.createElement(Field, {
                'name': 'clickLeadCaptureKitchen',
                'component': formCheckBoxField,
                'onChecked': this.updateCheckBoxField,
                'labelEnabled': 'Click to Lead Capture Visualizer',
                'labelDisabled': 'Click to Lead Capture Visualizer',
                'disabled': AR.d(PARTS.FAB_TOGGLE_BUTTON_BV_CLICK_TO_LEAD_CAPTURE),
                'key': '63884'
            }) : null),
            React.createElement('div', {
                'className': 'new-account-block-column new-account-block-column--half new-account-block-column--half_right',
                'key': '38691117'
            }, AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_CLICK_TO_LEAD_CAPTURE_DASHBOARD) ? React.createElement(Field, {
                'name': 'clickLeadCaptureDashboardKitchen',
                'component': formCheckBoxField,
                'onChecked': this.updateCheckBoxField,
                'labelEnabled': 'Click to Lead Capture (from Dashboard)',
                'labelDisabled': 'Click to Lead Capture (from Dashboard)',
                'disabled': AR.d(PARTS.FAB_TOGGLE_BUTTON_BV_CLICK_TO_LEAD_CAPTURE_DASHBOARD) || !this.props.formValues || this.props.formValues.leadCaptureDashboardKitchen && !this.props.formValues.clickLeadCaptureDashboardKitchen,
                'key': '64416'
            }) : null),
            React.createElement('div', {
                'className': 'new-account-block-column',
                'key': '38691119'
            }, this.props.formValues && (AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_CLICK_TO_LEAD_CAPTURE) && this.props.formValues.clickLeadCaptureKitchen || AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_CLICK_TO_LEAD_CAPTURE_DASHBOARD) && this.props.formValues.clickLeadCaptureDashboardKitchen) ? React.createElement(Field, {
                'name': 'clickLeadCountKitchen',
                'component': formField,
                'label': 'Click Count to Lead Capture Visualizer',
                'type': 'text',
                'key': '65079'
            }) : null),
            React.createElement('div', {
                'className': 'new-account-block-column new-account-block-column--half',
                'key': '38691121'
            }, AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_LEAD_CAPTURE_CONSUMERS) ? React.createElement(Field, {
                'name': 'leadCaptureOnQuoteKitchen',
                'component': formCheckBoxField,
                'onChecked': this.updateCheckBoxField,
                'labelEnabled': 'Lead Capture Consumers on Quote',
                'labelDisabled': 'Lead Capture Consumers on Quote',
                'disabled': AR.d(PARTS.FAB_TOGGLE_BUTTON_BV_LEAD_CAPTURE_CONSUMERS),
                'key': '65636'
            }) : null),
            React.createElement('div', {
                'className': 'new-account-block-column new-account-block-column--half new-account-block-column--half_right',
                'key': '38691123'
            }),
            React.createElement('div', {
                'className': 'new-account-block-column new-account-block-column--half',
                'key': '38691125'
            }, AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_CLICK_TO_LEAD_CAPTURE) ? React.createElement(Field, {
                'name': 'clickLeadCaptureOnQuoteKitchen',
                'component': formCheckBoxField,
                'onChecked': this.updateCheckBoxField,
                'labelEnabled': 'Click to Lead Capture On Quote',
                'labelDisabled': 'Click to Lead Capture On Quote',
                'disabled': AR.d(PARTS.FAB_TOGGLE_BUTTON_BV_CLICK_TO_LEAD_CAPTURE),
                'key': '66255'
            }) : null),
            React.createElement('div', {
                'className': 'new-account-block-column new-account-block-column--half new-account-block-column--half_right',
                'key': '38691127'
            }),
            React.createElement('div', {
                'className': 'new-account-block-column',
                'key': '38691129'
            }, this.props.formValues && (AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_CLICK_TO_LEAD_CAPTURE) && this.props.formValues.clickLeadCaptureOnQuoteKitchen || AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_CLICK_TO_LEAD_CAPTURE_DASHBOARD) && this.props.formValues.clickLeadCaptureDashboardKitchen) ? React.createElement(Field, {
                'name': 'clickLeadCountOnQuoteKitchen',
                'component': formField,
                'label': 'Click Count to Lead Capture On Quote',
                'type': 'text',
                'key': '66844'
            }) : null),
            React.createElement('div', {
                'className': 'new-account-block-column new-account-block-column--half',
                'key': '38691131'
            }, AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_ENABLE_GET_QUOTE) ? React.createElement(Field, {
                'name': 'enableQuoteKitchen',
                'component': formCheckBoxField,
                'onChecked': this.updateCheckBoxField,
                'labelEnabled': 'Enable Get Quote',
                'labelDisabled': 'Enable Get Quote',
                'disabled': AR.d(PARTS.FAB_TOGGLE_BUTTON_BV_ENABLE_GET_QUOTE) || !this.props.formValues,
                'key': '67413'
            }) : null),
            React.createElement('div', {
                'className': 'new-account-block-column new-account-block-column--half new-account-block-column--half_right',
                'key': '38691133'
            }, AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_ENABLE_GET_QUOTE_DASHBOARD) ? React.createElement(Field, {
                'name': 'enableQuoteDashboardKitchen',
                'component': formCheckBoxField,
                'onChecked': this.updateCheckBoxField,
                'labelEnabled': 'Enable Get Quote (from Dashboard)',
                'labelDisabled': 'Enable Get Quote (from Dashboard)',
                'disabled': AR.d(PARTS.FAB_TOGGLE_BUTTON_BV_ENABLE_GET_QUOTE_DASHBOARD) || !this.props.formValues,
                'key': '67924'
            }) : null),
            React.createElement('div', {
                'className': 'new-account-block-column new-account-block-column--half',
                'key': '38691135'
            }, AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_ENABLE_SCHEDULING) ? React.createElement(Field, {
                'name': 'enableSchedulingKitchen',
                'component': formCheckBoxField,
                'onChecked': this.updateCheckBoxField,
                'labelEnabled': 'Enable Scheduling',
                'labelDisabled': 'Enable Scheduling',
                'disabled': AR.d(PARTS.FAB_TOGGLE_BUTTON_BV_ENABLE_SCHEDULING),
                'key': '68461'
            }) : null),
            React.createElement('div', {
                'className': 'new-account-block-column new-account-block-column--half new-account-block-column--half_right',
                'key': '38691137'
            }, AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_ENABLE_SCHEDULING_DASHBOARD) ? React.createElement(Field, {
                'name': 'enableSchedulingDashboardKitchen',
                'component': formCheckBoxField,
                'onChecked': this.updateCheckBoxField,
                'labelEnabled': 'Enable Scheduling (from Dashboard)',
                'labelDisabled': 'Enable Scheduling (from Dashboard)',
                'disabled': AR.d(PARTS.FAB_TOGGLE_BUTTON_BV_ENABLE_SCHEDULING_DASHBOARD),
                'key': '68955'
            }) : null),
            React.createElement('div', {
                'className': 'new-account-block-column',
                'key': '38691139'
            }, AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_VISUALIZER_ONLY) ? React.createElement(Field, {
                'name': 'visualizerOnlyKitchen',
                'component': formCheckBoxField,
                'onChecked': this.updateCheckBoxField,
                'labelEnabled': 'Visualizer Only',
                'labelDisabled': 'Visualizer Only',
                'disabled': AR.d(PARTS.FAB_TOGGLE_BUTTON_BV_VISUALIZER_ONLY),
                'key': '69462'
            }) : null),
            React.createElement('div', {
                'className': 'new-account-block-column new-account-block-column--half',
                'key': '38691141'
            }, AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_SHOW_SMALL_BV_DESIGN_CONSUMERS) ? React.createElement(Field, {
                'name': 'showSmallBathroomDesignForClientsKitchen',
                'component': formCheckBoxField,
                'onChecked': this.updateCheckBoxField,
                'labelEnabled': 'Show Small Bathroom Design For Consumers',
                'labelDisabled': 'Show Small Bathroom Design For Consumers',
                'disabled': AR.d(PARTS.FAB_TOGGLE_BUTTON_BV_SHOW_SMALL_BV_DESIGN_CONSUMERS),
                'key': '69909'
            }) : null),
            React.createElement('div', {
                'className': 'new-account-block-column new-account-block-column--half new-account-block-column--half_right',
                'key': '38691143'
            }, AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_SHOW_SMALL_BV_DESIGN_DASHBOARD) ? React.createElement(Field, {
                'name': 'showSmallBathroomDesignFromDashboardKitchen',
                'component': formCheckBoxField,
                'onChecked': this.updateCheckBoxField,
                'labelEnabled': 'Show Small Bathroom Design From Dashboard',
                'labelDisabled': 'Show Small Bathroom Design From Dashboard',
                'disabled': AR.d(PARTS.FAB_TOGGLE_BUTTON_BV_SHOW_SMALL_BV_DESIGN_DASHBOARD),
                'key': '70528'
            }) : null),
            React.createElement('div', {
                'className': 'new-account-block-column new-account-block-column--half',
                'key': '38691145'
            }, AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_YES_NO_CONSULTATION) ? React.createElement(Field, {
                'name': 'yesNoConsultationRequestKitchen',
                'component': formCheckBoxField,
                'onChecked': this.updateCheckBoxField,
                'labelEnabled': 'Yes/No Consultation Request',
                'labelDisabled': 'Yes/No Consultation Request',
                'disabled': AR.d(PARTS.FAB_TOGGLE_BUTTON_BV_YES_NO_CONSULTATION),
                'key': '71115'
            }) : null),
            React.createElement('div', {
                'className': 'new-account-block-column new-account-block-column--half new-account-block-column--half_right',
                'key': '38691147'
            }, AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_ENABLE_CALENDAR_FOR_SCHEDULING) ? React.createElement(Field, {
                'name': 'enableCalendarForSchedulingKitchen',
                'component': formCheckBoxField,
                'onChecked': this.updateCheckBoxField,
                'labelEnabled': 'Enable Calendar for Scheduling',
                'labelDisabled': 'Enable Calendar for Scheduling',
                'disabled': AR.d(PARTS.FAB_TOGGLE_BUTTON_BV_ENABLE_CALENDAR_FOR_SCHEDULING),
                'key': '71641'
            }) : null),
            this.props.formValues && (this.props.formValues.yesNoConsultationRequestKitchen && AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_YES_NO_CONSULTATION)) ? React.createElement('div', {
                'className': 'new-account-block-column',
                'key': '38691149'
            }, React.createElement('div', {}, React.createElement(Field, {
                'name': 'noCallFabricatorIdKitchen',
                'component': hiddenField
            }), React.createElement(Field, {
                'name': 'noCallFabricatorNameKitchen',
                'component': formField,
                'label': 'No Call Fabricator',
                'type': 'text',
                'disabled': true
            })), React.createElement('button', {
                'className': 'ui-button2 ui-button2--blue',
                'onClick': onClick26.bind(this, showSendResetPasswordPopup, showChangePasswordPopup, user, clientType, handleClosePopup, handleShowPopup, authGoogleCalendar, isEmployee, isCustomer, isFabricator, isMasterFabricator, isStore, isNew, AR, isMaster, canEditFields, canChangePassword, canAddFabricator, paymentProfile, canEditPrimaryEmail, subscriptionEditable, fabricatorId),
                'type': 'button'
            }, 'Change\r\n          ')) : null,
            React.createElement('div', {
                'className': 'new-account-block-column new-account-block-column--half',
                'key': '38691151'
            }, AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_AUTO_CALL_FABRICATOR_LEAD) ? React.createElement(Field, {
                'name': 'enableFabricatorAutoCallKitchen',
                'component': formCheckBoxField,
                'onChecked': this.updateCheckBoxField,
                'labelEnabled': 'Auto-Call Fabricator with New Lead',
                'labelDisabled': 'Auto-Call Fabricator with New Lead',
                'disabled': AR.d(PARTS.FAB_TOGGLE_BUTTON_BV_AUTO_CALL_FABRICATOR_LEAD),
                'key': '72942'
            }) : null),
            React.createElement('div', {
                'className': 'new-account-block-column new-account-block-column--half new-account-block-column--half_right',
                'key': '38691153'
            }, AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_AUTO_CALL_FABRICATOR_FROM_DASHBOARD) ? React.createElement(Field, {
                'name': 'enableFabricatorAutoCallDashboardKitchen',
                'component': formCheckBoxField,
                'onChecked': this.updateCheckBoxField,
                'labelEnabled': 'Auto-Call with New Lead From Dashboard',
                'labelDisabled': 'Auto-Call with New Lead From Dashboard',
                'disabled': AR.d(PARTS.FAB_TOGGLE_BUTTON_BV_AUTO_CALL_FABRICATOR_FROM_DASHBOARD),
                'key': '73512'
            }) : null),
            React.createElement('div', {
                'className': 'new-account-block-column new-account-block-column--half',
                'key': '38691155'
            }, React.createElement(Field, {
                'name': 'enableCookiePopupKitchen',
                'component': formCheckBoxField,
                'onChecked': this.updateCheckBoxField,
                'labelEnabled': 'Enable Cookie Popup',
                'labelDisabled': 'Enable Cookie Popup'
            })),
            React.createElement('div', {
                'className': 'new-account-block-column new-account-block-column--half',
                'key': '38691157'
            }),
            React.createElement('div', {
                'className': 'new-account-block-column new-account-block-column--half',
                'key': '38691159'
            }, React.createElement(Field, {
                'name': 'enableSqFtKitchen',
                'component': formCheckBoxField,
                'onChecked': this.updateCheckBoxField,
                'labelEnabled': 'Disable SQFT',
                'labelDisabled': 'Disable SQFT'
            })),
            React.createElement('div', {
                'className': 'new-account-block-column new-account-block-column--half',
                'key': '38691161'
            }),
            React.createElement('div', {
                'className': 'new-account-block-column new-account-block-column--half',
                'key': '38691163'
            }, React.createElement(Field, {
                'name': 'leadCaptureShoppingCartKitchen',
                'component': formCheckBoxField,
                'onChecked': this.updateCheckBoxField,
                'labelEnabled': 'Lead Capture Shopping Cart',
                'labelDisabled': 'Lead Capture Shopping Cart'
            })),
            React.createElement('div', {
                'className': 'new-account-block-column new-account-block-column--half',
                'key': '38691165'
            }, React.createElement(Field, {
                'name': 'leadCaptureShoppingCartDashboardKitchen',
                'component': formCheckBoxField,
                'onChecked': this.updateCheckBoxField,
                'labelEnabled': 'Lead Capture Shopping Cart (Dashboard)',
                'labelDisabled': 'Lead Capture Shopping Cart (Dashboard)'
            })),
            React.createElement('div', {
                'className': 'new-account-block-column new-account-block-column--half',
                'key': '38691167'
            }, React.createElement(Field, {
                'name': 'showRecentlyViewedItemsKitchen',
                'component': formCheckBoxField,
                'onChecked': this.updateCheckBoxField,
                'labelEnabled': 'Show Recently Viewed Items',
                'labelDisabled': 'Show Recently Viewed Items'
            })),
            React.createElement('div', {
                'className': 'new-account-block-column new-account-block-column--half',
                'key': '38691169'
            }),
            React.createElement('div', {
                'className': 'new-account-block-column new-account-block-column--half',
                'key': '38691171'
            }, React.createElement(Field, {
                'name': 'showTutorialVideo',
                'component': formCheckBoxField,
                'onChecked': this.updateCheckBoxField,
                'labelEnabled': 'Show Tutorial Video',
                'labelDisabled': 'Show Tutorial Video'
            })),
            React.createElement('div', {
                'className': 'new-account-block-column new-account-block-column--half',
                'key': '38691173'
            }),
            React.createElement('div', {
                'className': 'new-account-block-column new-account-block-column--half',
                'style': {
                    marginTop: '10px',
                    paddingTop: '10px',
                    borderTop: '1px solid #4A90E2'
                },
                'key': '38691175'
            }, React.createElement(Dropdown, {
                'id': 'currencyDropdown',
                'values': [
                    'USD',
                    'EUR',
                    'GBP',
                    'CAD'
                ],
                'activeValue': this.state.activeCurrency,
                'underlineText': 'Select currency',
                'onChange': onChange27.bind(this, showSendResetPasswordPopup, showChangePasswordPopup, user, clientType, handleClosePopup, handleShowPopup, authGoogleCalendar, isEmployee, isCustomer, isFabricator, isMasterFabricator, isStore, isNew, AR, isMaster, canEditFields, canChangePassword, canAddFabricator, paymentProfile, canEditPrimaryEmail, subscriptionEditable, fabricatorId)
            })),
            ,
            React.createElement('div', {
                'className': 'new-account-block new-account-block-column',
                'key': '38691179'
            }, React.createElement('div', { 'className': 'new-account-block-sub-lir' }, React.createElement('div', { 'className': 'new-accouunt-block-column new-account-block-column--half separator-bottom' }), React.createElement('div', { 'className': 'new-accouunt-block-column new-account-block-column--half new-account-block-column--half_right separator-bottom' }))),
            React.createElement('h3', { 'key': '38691181' }, 'Common Props props'),
            React.createElement('div', {
                'className': 'new-account-block-column new-account-block-column--half',
                'key': '38691183'
            }, React.createElement(Field, {
                'name': 'docuSignAuth',
                'component': hiddenField
            }), AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_ENABLE_DOCUSIGN) ? React.createElement(Field, {
                'name': 'enableDocuSign',
                'component': formCheckBoxField,
                'onChecked': this.updateCheckBoxField,
                'labelEnabled': 'Enable DocuSign',
                'labelDisabled': 'Enable DocuSign',
                'disabled': AR.d(PARTS.FAB_TOGGLE_BUTTON_BV_ENABLE_DOCUSIGN) || this.props.formValues && this.props.formValues.enableFingerSignature,
                'key': '77510'
            }) : null, this.props.formValues && this.props.formValues.enableDocuSign && AR.v(PARTS.FAB_TOGGLE_BUTTON_BV_ENABLE_DOCUSIGN) ? React.createElement('button', {
                'className': 'ui-button2 ui-button2--blue',
                'onClick': onClick28.bind(this, showSendResetPasswordPopup, showChangePasswordPopup, user, clientType, handleClosePopup, handleShowPopup, authGoogleCalendar, isEmployee, isCustomer, isFabricator, isMasterFabricator, isStore, isNew, AR, isMaster, canEditFields, canChangePassword, canAddFabricator, paymentProfile, canEditPrimaryEmail, subscriptionEditable, fabricatorId),
                'type': 'button',
                'key': '77947'
            }, 'Set DocuSign parameters\r\n          ') : null),
            React.createElement('div', {
                'className': 'new-account-block-column new-account-block-column--half',
                'key': '38691185'
            }),
            React.createElement('div', {
                'className': 'new-account-block-column new-account-block-column--half',
                'key': '38691187'
            }, React.createElement(Field, {
                'name': 'enableFingerSignature',
                'component': formCheckBoxField,
                'onChecked': this.updateCheckBoxField,
                'labelEnabled': 'Enable Finger Signature',
                'labelDisabled': 'Enable Finger Signature',
                'disabled': this.props.formValues && this.props.formValues.enableDocuSign
            })),
            this.props.formValues && this.props.formValues.enableFingerSignature ? React.createElement('div', {
                'className': 'new-account-block-column new-account-block-column--half',
                'key': '38691189'
            }) : null,
            this.props.formValues && this.props.formValues.enableFingerSignature ? React.createElement('div', {
                'className': 'new-account-block-column new-account-block-column--half',
                'key': '38691191'
            }, React.createElement(Field, {
                'name': 'fingerSignatureTermsAcceptedAt',
                'component': hiddenField
            }), React.createElement(Field, {
                'name': 'fingerSignatureMasterDocumentFullUrl',
                'component': hiddenField
            }), React.createElement('button', {
                'className': 'ui-button2 ui-button2--blue',
                'onClick': onClick29.bind(this, showSendResetPasswordPopup, showChangePasswordPopup, user, clientType, handleClosePopup, handleShowPopup, authGoogleCalendar, isEmployee, isCustomer, isFabricator, isMasterFabricator, isStore, isNew, AR, isMaster, canEditFields, canChangePassword, canAddFabricator, paymentProfile, canEditPrimaryEmail, subscriptionEditable, fabricatorId),
                'type': 'button'
            }, 'Set Master Document\r\n          ')) : null,
            React.createElement('div', {
                'className': 'new-account-block-column new-account-block-column--half',
                'key': '38691193'
            }, React.createElement(Field, {
                'name': 'webHookProperties.url',
                'component': formField,
                'label': 'WebHook Url',
                'type': 'text',
                'disabled': !canEditFields
            }), React.createElement(Dropdown, {
                'id': 'webHookDataTypeDropdown',
                'values': [
                    'Json',
                    'FormData'
                ],
                'activeValue': this.state.activeWebHookDataType,
                'underlineText': 'Select DataType',
                'onChange': onChange30.bind(this, showSendResetPasswordPopup, showChangePasswordPopup, user, clientType, handleClosePopup, handleShowPopup, authGoogleCalendar, isEmployee, isCustomer, isFabricator, isMasterFabricator, isStore, isNew, AR, isMaster, canEditFields, canChangePassword, canAddFabricator, paymentProfile, canEditPrimaryEmail, subscriptionEditable, fabricatorId)
            }), React.createElement(Field, {
                'name': 'webHookProperties.onNewLead',
                'component': formCheckBoxField,
                'onChecked': this.updateCheckBoxField,
                'labelEnabled': 'Enable Webhook On New Lead Creation',
                'labelDisabled': 'Enable Webhook On New Lead Creation'
            }), React.createElement(Field, {
                'name': 'webHookProperties.onNewJob',
                'component': formCheckBoxField,
                'onChecked': this.updateCheckBoxField,
                'labelEnabled': 'Enable Webhook On New Job Creation',
                'labelDisabled': 'Enable Webhook On New Job Creation'
            }), React.createElement(Field, {
                'name': 'webHookProperties.onUpdateJob',
                'component': formCheckBoxField,
                'onChecked': this.updateCheckBoxField,
                'labelEnabled': 'Enable Webhook On Job Update',
                'labelDisabled': 'Enable Webhook On Job Update'
            }), React.createElement(Field, {
                'name': 'webHookProperties.useLeadConduit',
                'component': formCheckBoxField,
                'onChecked': this.updateCheckBoxField,
                'labelEnabled': 'Use LeadConduit',
                'labelDisabled': 'Use LeadConduit'
            }))
        ]) : null), this.state.showCreditCardOverlay ? React.createElement('div', {
            'className': 'new-account-creditcard-overlay-container',
            'onClick': onClick31.bind(this, showSendResetPasswordPopup, showChangePasswordPopup, user, clientType, handleClosePopup, handleShowPopup, authGoogleCalendar, isEmployee, isCustomer, isFabricator, isMasterFabricator, isStore, isNew, AR, isMaster, canEditFields, canChangePassword, canAddFabricator, paymentProfile, canEditPrimaryEmail, subscriptionEditable, fabricatorId),
            'key': '81232'
        }, React.createElement('div', {
            'className': 'new-account-creditcard-overlay',
            'onClick': onClick32.bind(this, showSendResetPasswordPopup, showChangePasswordPopup, user, clientType, handleClosePopup, handleShowPopup, authGoogleCalendar, isEmployee, isCustomer, isFabricator, isMasterFabricator, isStore, isNew, AR, isMaster, canEditFields, canChangePassword, canAddFabricator, paymentProfile, canEditPrimaryEmail, subscriptionEditable, fabricatorId)
        }, React.createElement('div', { 'className': 'new-account-creditcard-overlay-header' }, React.createElement('div', { 'className': 'new-account-creditcard-overlay-header--title' }, '\r\n          ', this.state.saveCC || paymentProfile.customerProfileId ? 'Update' : 'Add', ' Credit Card\r\n        '), React.createElement('div', { 'className': 'new-account-creditcard-overlay-header--controlbox' }, React.createElement('button', { 'onClick': onClick33.bind(this, showSendResetPasswordPopup, showChangePasswordPopup, user, clientType, handleClosePopup, handleShowPopup, authGoogleCalendar, isEmployee, isCustomer, isFabricator, isMasterFabricator, isStore, isNew, AR, isMaster, canEditFields, canChangePassword, canAddFabricator, paymentProfile, canEditPrimaryEmail, subscriptionEditable, fabricatorId) }, 'X'))), React.createElement('div', { 'className': 'new-account-creditcard-overlay-body' }, React.createElement('div', { 'className': 'field-row' }, React.createElement('input', {
            'className': 'label-jump',
            'type': 'text',
            'placeholder': 'Name on Card',
            'value': this.state.ccName,
            'required': true,
            'onChange': e => this.setState({ ccName: e.target.value })
        }), React.createElement('label', {}, 'Name on Card')), React.createElement('div', { 'className': 'field-row' }, React.createElement('input', {
            'className': 'label-jump',
            'type': 'text',
            'placeholder': 'Card Number',
            'value': this.state.ccNum,
            'required': true,
            'onChange': e => this.setState({
                ccNum: e.target.value,
                ccType: misc.detectCardType(e.target.value)
            })
        }), React.createElement('label', {}, 'Card Number'), React.createElement('label', { 'className': 'field-short field-short--right ' + (this.state.ccType ? 'show' : '') }, '\r\n            ', this.state.ccType, '\r\n          ')), React.createElement('div', { 'className': 'field-row' }, React.createElement('div', { 'className': 'field-short' }, React.createElement('input', {
            'type': 'text',
            'placeholder': 'MM',
            'maxLength': '2',
            'size': '2',
            'required': true,
            'value': this.state.ccExpMonth,
            'onChange': e => this.setState({ ccExpMonth: e.target.value })
        }), '/\r\n            ', React.createElement('input', {
            'type': 'text',
            'placeholder': 'YY',
            'maxLength': '2',
            'size': '2',
            'required': true,
            'value': this.state.ccExpYear,
            'onChange': e => this.setState({ ccExpYear: e.target.value })
        }), React.createElement('label', {}, 'Exp. Date')), React.createElement('div', { 'className': 'field-short field-short--right' }, React.createElement('label', {}, 'CVV/CVC'), React.createElement('input', {
            'type': 'text',
            'placeholder': 'CVV',
            'maxLength': '4',
            'size': '4',
            'required': true,
            'value': this.state.ccCVV,
            'onChange': e => this.setState({ ccCVV: e.target.value })
        }))), React.createElement('div', { 'className': 'field-row' }, React.createElement('textarea', {
            'className': 'terms',
            'readOnly': true,
            'value': 'I authorize the above named business to charge the credit card indicated in this authorization form according to the terms outlined above. If the above noted payment dates fall on a weekend or holiday, I understand that the payments may be executed on the next business day. I understand that this authorization will remain in effect until I cancel it in email or writing, and I agree to notify the business in writing of any changes in my account information or termination of this authorization at least 30 days prior to the next billing date. This payment authorization is for the type of bill indicated above. I certify that I am an authorized user of this credit card and that I will not dispute the scheduled payments with my credit card company provided the transactions correspond to the terms indicated in this authorization form. By signing this agreement above signer waives the right to file a chargeback with credit card company once software profile is built. Here\u2019s How Recurring Payments Work: You authorize regularly scheduled charges to your Visa, MasterCard, American Express or Discover card. You will be charged each billing period for the total amount due for that period. A receipt will be emailed to you and the charge will appear on your credit card statement. You agree that no prior-notification will be provided unless your bill is more than the amount stated below, or the payment date changes, in which case you will receive notice from us at least 10 days prior to the payment being collected.'
        }), React.createElement(CheckBox, {
            'checked': this.state.ccTermsApproved,
            'text': 'I agree to the terms of use for the credit card information entered above',
            ',': true,
            'onChecked': onChecked34.bind(this, showSendResetPasswordPopup, showChangePasswordPopup, user, clientType, handleClosePopup, handleShowPopup, authGoogleCalendar, isEmployee, isCustomer, isFabricator, isMasterFabricator, isStore, isNew, AR, isMaster, canEditFields, canChangePassword, canAddFabricator, paymentProfile, canEditPrimaryEmail, subscriptionEditable, fabricatorId)
        }))), React.createElement('div', { 'className': 'new-account-creditcard-overlay-footer' }, React.createElement('button', {
            'className': 'ui-button2 ui-button2--blue',
            'onClick': onClick35.bind(this, showSendResetPasswordPopup, showChangePasswordPopup, user, clientType, handleClosePopup, handleShowPopup, authGoogleCalendar, isEmployee, isCustomer, isFabricator, isMasterFabricator, isStore, isNew, AR, isMaster, canEditFields, canChangePassword, canAddFabricator, paymentProfile, canEditPrimaryEmail, subscriptionEditable, fabricatorId)
        }, '\r\n          Cancel\r\n        '), React.createElement('button', {
            'className': 'ui-button2 ui-button2--green',
            'onClick': this.saveCC
        }, 'Continue')))) : null, this.state.showDocuSignOverlay ? React.createElement('div', {
            'className': 'new-account-creditcard-overlay-container',
            'key': '85842'
        }, React.createElement('div', {
            'className': 'new-account-creditcard-overlay',
            'onClick': onClick36.bind(this, showSendResetPasswordPopup, showChangePasswordPopup, user, clientType, handleClosePopup, handleShowPopup, authGoogleCalendar, isEmployee, isCustomer, isFabricator, isMasterFabricator, isStore, isNew, AR, isMaster, canEditFields, canChangePassword, canAddFabricator, paymentProfile, canEditPrimaryEmail, subscriptionEditable, fabricatorId),
            'style': { height: '555px' }
        }, React.createElement('div', { 'className': 'new-account-creditcard-overlay-header' }, React.createElement('div', { 'className': 'new-account-creditcard-overlay-header--title' }, '\r\n          Set DocuSign Parameters\r\n        '), React.createElement('div', { 'className': 'new-account-creditcard-overlay-header--controlbox' }, React.createElement('button', { 'onClick': onClick37.bind(this, showSendResetPasswordPopup, showChangePasswordPopup, user, clientType, handleClosePopup, handleShowPopup, authGoogleCalendar, isEmployee, isCustomer, isFabricator, isMasterFabricator, isStore, isNew, AR, isMaster, canEditFields, canChangePassword, canAddFabricator, paymentProfile, canEditPrimaryEmail, subscriptionEditable, fabricatorId) }, 'X'))), React.createElement('div', { 'className': 'new-account-creditcard-overlay-body' }, React.createElement('div', { 'className': 'field-row' }, React.createElement('input', {
            'className': 'label-jump',
            'type': 'text',
            'placeholder': 'SandBox User Id',
            'value': this.state.ds_sandBoxUserId,
            'required': true,
            'onChange': e => this.setState({ ds_sandBoxUserId: e.target.value })
        }), React.createElement('label', {}, 'SandBox User Id')), React.createElement('div', { 'className': 'field-row' }, React.createElement('input', {
            'className': 'label-jump',
            'type': 'text',
            'placeholder': 'SandBox Authentication Token',
            'value': this.state.ds_sandBoxAuthToken,
            'required': true,
            'onChange': e => this.setState({ ds_sandBoxAuthToken: e.target.value })
        }), React.createElement('label', {}, 'SandBox Authentication Token'), React.createElement('a', {
            'href': '#',
            'rel': 'external',
            'onClick': onClick38.bind(this, showSendResetPasswordPopup, showChangePasswordPopup, user, clientType, handleClosePopup, handleShowPopup, authGoogleCalendar, isEmployee, isCustomer, isFabricator, isMasterFabricator, isStore, isNew, AR, isMaster, canEditFields, canChangePassword, canAddFabricator, paymentProfile, canEditPrimaryEmail, subscriptionEditable, fabricatorId)
        }, 'Get it\r\n            here')), React.createElement('div', { 'className': 'field-row' }, React.createElement('input', {
            'className': 'label-jump',
            'type': 'text',
            'placeholder': 'Production Client Id',
            'value': this.state.ds_prodClientId,
            'required': true,
            'onChange': e => this.setState({ ds_prodClientId: e.target.value })
        }), React.createElement('label', {}, 'Production Client id')), React.createElement('div', { 'className': 'field-row' }, React.createElement('input', {
            'className': 'label-jump',
            'type': 'text',
            'placeholder': 'Production User Id',
            'value': this.state.ds_prodUserId,
            'required': true,
            'onChange': e => this.setState({ ds_prodUserId: e.target.value })
        }), React.createElement('label', {}, 'Production User id')), React.createElement('div', {
            'className': 'field-row',
            'style': { height: 'auto' }
        }, React.createElement('textarea', {
            'className': 'terms',
            'placeholder': 'Production Private Key',
            'value': this.state.ds_prodPrivateKey,
            'required': true,
            'onChange': e => this.setState({ ds_prodPrivateKey: e.target.value })
        }), React.createElement('label', {}, 'Production Private Key')), React.createElement('div', { 'className': 'field-row' }, React.createElement('input', {
            'className': 'label-jump',
            'type': 'text',
            'placeholder': 'CheckOut Template Id',
            'value': this.state.ds_checkOutContractId,
            'required': true,
            'onChange': e => this.setState({ ds_checkOutContractId: e.target.value })
        }), React.createElement('label', {}, 'CheckOut Template Id')), React.createElement('div', { 'className': 'field-row' }, React.createElement(CheckBox, {
            'checked': this.state.ds_isProduction,
            'text': 'Enable Production Mode',
            'onChecked': onChecked39.bind(this, showSendResetPasswordPopup, showChangePasswordPopup, user, clientType, handleClosePopup, handleShowPopup, authGoogleCalendar, isEmployee, isCustomer, isFabricator, isMasterFabricator, isStore, isNew, AR, isMaster, canEditFields, canChangePassword, canAddFabricator, paymentProfile, canEditPrimaryEmail, subscriptionEditable, fabricatorId)
        }))), React.createElement('div', { 'className': 'new-account-creditcard-overlay-footer' }, React.createElement('button', {
            'className': 'ui-button2 ui-button2--blue',
            'onClick': onClick40.bind(this, showSendResetPasswordPopup, showChangePasswordPopup, user, clientType, handleClosePopup, handleShowPopup, authGoogleCalendar, isEmployee, isCustomer, isFabricator, isMasterFabricator, isStore, isNew, AR, isMaster, canEditFields, canChangePassword, canAddFabricator, paymentProfile, canEditPrimaryEmail, subscriptionEditable, fabricatorId)
        }, '\r\n          Cancel\r\n        '), React.createElement('button', {
            'className': 'ui-button2 ui-button2--green',
            'onClick': this.saveDocuSign
        }, 'Continue')))) : null, this.props.showESignatureOverlay && this.props.formValues ? React.createElement('div', {
            'className': 'new-account-creditcard-overlay-iframe',
            'onClick': onClick41.bind(this, showSendResetPasswordPopup, showChangePasswordPopup, user, clientType, handleClosePopup, handleShowPopup, authGoogleCalendar, isEmployee, isCustomer, isFabricator, isMasterFabricator, isStore, isNew, AR, isMaster, canEditFields, canChangePassword, canAddFabricator, paymentProfile, canEditPrimaryEmail, subscriptionEditable, fabricatorId),
            'key': '89293'
        }, React.createElement(ESignature, {
            'firstName': this.props.formValues.firstName,
            'lastName': this.props.formValues.lastName,
            'email': this.props.formValues.primaryEmail,
            'programType': this.state[this.state.programTypeKey + 'ProgramType'],
            'paymentType': this.state[this.state.programTypeKey + 'PaymentType'].period,
            'paymentAmount': +this.state[this.state.programTypeKey + 'PaymentAmount'],
            'businessName': this.props.formValues.companyName,
            'businessPhone': this.props.formValues.phone1,
            'businessWebSite': this.props.formValues.redirectURL,
            'last4CC': misc.last4(this.state.ccNum),
            'formSubmittedFn': this.handleJotFormSubmitted
        })) : null, this.state.showPaymentGateways ? React.createElement('div', {
            'className': 'ui-popup--overlay',
            'onClick': onClick42.bind(this, showSendResetPasswordPopup, showChangePasswordPopup, user, clientType, handleClosePopup, handleShowPopup, authGoogleCalendar, isEmployee, isCustomer, isFabricator, isMasterFabricator, isStore, isNew, AR, isMaster, canEditFields, canChangePassword, canAddFabricator, paymentProfile, canEditPrimaryEmail, subscriptionEditable, fabricatorId),
            'key': '90240'
        }, React.createElement('div', {
            'className': 'ui-popup ui-popup--wide',
            'onClick': onClick43.bind(this, showSendResetPasswordPopup, showChangePasswordPopup, user, clientType, handleClosePopup, handleShowPopup, authGoogleCalendar, isEmployee, isCustomer, isFabricator, isMasterFabricator, isStore, isNew, AR, isMaster, canEditFields, canChangePassword, canAddFabricator, paymentProfile, canEditPrimaryEmail, subscriptionEditable, fabricatorId)
        }, React.createElement('div', { 'className': 'ui-popup-header' }, React.createElement('span', { 'className': 'ui-popup-header__text' }, 'Payment Gateways')), React.createElement('div', { 'className': 'ui-popup-body ui-popup-body--tiny' }, React.createElement('ul', { 'className': 'manage-payment-gateways' }, React.createElement('li', {
            'onClick': onClick44.bind(this, showSendResetPasswordPopup, showChangePasswordPopup, user, clientType, handleClosePopup, handleShowPopup, authGoogleCalendar, isEmployee, isCustomer, isFabricator, isMasterFabricator, isStore, isNew, AR, isMaster, canEditFields, canChangePassword, canAddFabricator, paymentProfile, canEditPrimaryEmail, subscriptionEditable, fabricatorId),
            'className': classNames('manage-payment-gateways-listItem', { 'manage-payment-gateways-listItem--selected': this.state.paymentGatewayManaging == 'authnet' })
        }, 'Authorize.Net\r\n          '), false ? React.createElement('li', {
            'onClick': onClick45.bind(this, showSendResetPasswordPopup, showChangePasswordPopup, user, clientType, handleClosePopup, handleShowPopup, authGoogleCalendar, isEmployee, isCustomer, isFabricator, isMasterFabricator, isStore, isNew, AR, isMaster, canEditFields, canChangePassword, canAddFabricator, paymentProfile, canEditPrimaryEmail, subscriptionEditable, fabricatorId),
            'className': classNames('manage-payment-gateways-listItem', { 'manage-payment-gateways-listItem--selected': this.state.paymentGatewayManaging == 'paypalpro' }),
            'key': '90997'
        }, 'PayPal Payments Pro\r\n          ') : null, false ? React.createElement('li', {
            'onClick': onClick46.bind(this, showSendResetPasswordPopup, showChangePasswordPopup, user, clientType, handleClosePopup, handleShowPopup, authGoogleCalendar, isEmployee, isCustomer, isFabricator, isMasterFabricator, isStore, isNew, AR, isMaster, canEditFields, canChangePassword, canAddFabricator, paymentProfile, canEditPrimaryEmail, subscriptionEditable, fabricatorId),
            'className': classNames('manage-payment-gateways-listItem', { 'manage-payment-gateways-listItem--selected': this.state.paymentGatewayManaging == 'paypalstd' }),
            'key': '91329'
        }, 'PayPal Payments Standard\r\n          ') : null), React.createElement('div', { 'className': 'manage-payment-gateways--gateway' }, this.state.paymentGatewayManaging == 'authnet' ? [
            React.createElement('label', { 'key': '917371' }, 'API Login'),
            React.createElement('input', {
                'type': 'text',
                'value': this.state.paymentGateway_AuthNet_ApiLogin,
                'onChange': onChange47.bind(this, showSendResetPasswordPopup, showChangePasswordPopup, user, clientType, handleClosePopup, handleShowPopup, authGoogleCalendar, isEmployee, isCustomer, isFabricator, isMasterFabricator, isStore, isNew, AR, isMaster, canEditFields, canChangePassword, canAddFabricator, paymentProfile, canEditPrimaryEmail, subscriptionEditable, fabricatorId),
                'maxLength': 9,
                'placeholder': 'Auth.NET API Key',
                'key': '917373'
            }),
            React.createElement('label', { 'key': '917375' }, 'Transaction Key'),
            React.createElement('input', {
                'type': 'text',
                'value': this.state.paymentGateway_AuthNet_TransactionKey,
                'onChange': onChange48.bind(this, showSendResetPasswordPopup, showChangePasswordPopup, user, clientType, handleClosePopup, handleShowPopup, authGoogleCalendar, isEmployee, isCustomer, isFabricator, isMasterFabricator, isStore, isNew, AR, isMaster, canEditFields, canChangePassword, canAddFabricator, paymentProfile, canEditPrimaryEmail, subscriptionEditable, fabricatorId),
                'maxLength': 16,
                'placeholder': 'Auth.NET Transaction Key',
                'key': '917377'
            }),
            React.createElement(CheckBox, {
                'checked': this.state.paymentGateway_AuthNet_TestMode,
                'text': 'Test Mode (use developer sandbox api endpoint)',
                ',': true,
                'onChecked': onChecked49.bind(this, showSendResetPasswordPopup, showChangePasswordPopup, user, clientType, handleClosePopup, handleShowPopup, authGoogleCalendar, isEmployee, isCustomer, isFabricator, isMasterFabricator, isStore, isNew, AR, isMaster, canEditFields, canChangePassword, canAddFabricator, paymentProfile, canEditPrimaryEmail, subscriptionEditable, fabricatorId),
                'key': '917379'
            })
        ] : null)), React.createElement('div', { 'className': 'ui-popup-footer' }, React.createElement('a', {
            'className': 'ui-button2 ui-button2--small ui-button2--blue',
            'style': { marginRight: '5px' },
            'onClick': onClick50.bind(this, showSendResetPasswordPopup, showChangePasswordPopup, user, clientType, handleClosePopup, handleShowPopup, authGoogleCalendar, isEmployee, isCustomer, isFabricator, isMasterFabricator, isStore, isNew, AR, isMaster, canEditFields, canChangePassword, canAddFabricator, paymentProfile, canEditPrimaryEmail, subscriptionEditable, fabricatorId)
        }, 'Cancel'), React.createElement('a', {
            'className': 'ui-button2 ui-button2--small ui-button2--green',
            'onClick': this.savePaymentGateways
        }, 'Save')))) : null, this.state.showDepositDisclaimer ? React.createElement('div', {
            'className': 'ui-popup--overlay',
            'onClick': onClick51.bind(this, showSendResetPasswordPopup, showChangePasswordPopup, user, clientType, handleClosePopup, handleShowPopup, authGoogleCalendar, isEmployee, isCustomer, isFabricator, isMasterFabricator, isStore, isNew, AR, isMaster, canEditFields, canChangePassword, canAddFabricator, paymentProfile, canEditPrimaryEmail, subscriptionEditable, fabricatorId),
            'key': '93129'
        }, React.createElement('div', {
            'className': 'ui-popup ui-popup--wide',
            'onClick': onClick52.bind(this, showSendResetPasswordPopup, showChangePasswordPopup, user, clientType, handleClosePopup, handleShowPopup, authGoogleCalendar, isEmployee, isCustomer, isFabricator, isMasterFabricator, isStore, isNew, AR, isMaster, canEditFields, canChangePassword, canAddFabricator, paymentProfile, canEditPrimaryEmail, subscriptionEditable, fabricatorId)
        }, React.createElement('div', { 'className': 'ui-popup-header' }, React.createElement('span', { 'className': 'ui-popup-header__text' }, 'Edit Disclaimer'), React.createElement('div', {
            'className': 'ui-popup-header__close',
            'onClick': onClick53.bind(this, showSendResetPasswordPopup, showChangePasswordPopup, user, clientType, handleClosePopup, handleShowPopup, authGoogleCalendar, isEmployee, isCustomer, isFabricator, isMasterFabricator, isStore, isNew, AR, isMaster, canEditFields, canChangePassword, canAddFabricator, paymentProfile, canEditPrimaryEmail, subscriptionEditable, fabricatorId)
        })), React.createElement('div', { 'className': 'ui-popup-body ui-popup-body--tiny' }, React.createElement('textarea', {
            'placeholder': 'Deposit Disclaimer message',
            'value': this.state.editDepositDisclaimer,
            'onChange': onChange54.bind(this, showSendResetPasswordPopup, showChangePasswordPopup, user, clientType, handleClosePopup, handleShowPopup, authGoogleCalendar, isEmployee, isCustomer, isFabricator, isMasterFabricator, isStore, isNew, AR, isMaster, canEditFields, canChangePassword, canAddFabricator, paymentProfile, canEditPrimaryEmail, subscriptionEditable, fabricatorId)
        })), React.createElement('div', { 'className': 'ui-popup-footer' }, React.createElement('a', {
            'className': 'ui-button2 ui-button2--small ui-button2--blue',
            'style': { marginRight: '5px' },
            'onClick': onClick55.bind(this, showSendResetPasswordPopup, showChangePasswordPopup, user, clientType, handleClosePopup, handleShowPopup, authGoogleCalendar, isEmployee, isCustomer, isFabricator, isMasterFabricator, isStore, isNew, AR, isMaster, canEditFields, canChangePassword, canAddFabricator, paymentProfile, canEditPrimaryEmail, subscriptionEditable, fabricatorId)
        }, 'Cancel'), React.createElement('a', {
            'className': 'ui-button2 ui-button2--small ui-button2--blue',
            'style': { marginRight: '5px' },
            'onClick': onClick56.bind(this, showSendResetPasswordPopup, showChangePasswordPopup, user, clientType, handleClosePopup, handleShowPopup, authGoogleCalendar, isEmployee, isCustomer, isFabricator, isMasterFabricator, isStore, isNew, AR, isMaster, canEditFields, canChangePassword, canAddFabricator, paymentProfile, canEditPrimaryEmail, subscriptionEditable, fabricatorId)
        }, 'Restore\r\n          Default'), React.createElement('a', {
            'className': 'ui-button2 ui-button2--small ui-button2--green',
            'onClick': this.saveDisclaimer
        }, 'Save')))) : null, this.props.showFingerSignatureOverlay && !isNew ? React.createElement('div', {
            'className': 'ui-popup--overlay',
            'key': '94523'
        }, React.createElement(FingerSignature, {
            'fabricatorId': fabricatorId,
            'closeCb': this.handleSetFabricatorMasterDocument,
            'fabricator': this.props.formValues
        })) : null);
    }
    return scopeShowSendResetPasswordPopupShowChangePasswordPopupUserClientTypeHandleClosePopupHandleShowPopupAuthGoogleCalendarIsEmployeeIsCustomerIsFabricatorIsMasterFabricatorIsStoreIsNewARIsMasterCanEditFieldsCanChangePasswordCanAddFabricatorPaymentProfileCanEditPrimaryEmailSubscriptionEditableFabricatorId57.apply(this, []);
}